import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DisabledNavigation from "./DisabledNavigation";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { ShieldCheckIcon } from "@heroicons/react/20/solid";
import RolesPermissions from "../product/settings/components/RolesPermissions";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import KeyboardOutlinedIcon from "@mui/icons-material/KeyboardOutlined";
import LaunchIcon from "@mui/icons-material/Launch";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import RestaurantOutlinedIcon from "@mui/icons-material/RestaurantOutlined";
import RepartitionIcon from "@mui/icons-material/Repartition";
import SearchIcon from "@mui/icons-material/Search";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Backdrop, Badge, CircularProgress, IconButton } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { styled, useTheme } from "@mui/material/styles";
import { useQuery } from "@tanstack/react-query";
import { UserContext } from "App";
import ScannerImage from "assets/images/border.png";
import DefaultLogo from "assets/images/default_pos_logo.png";
import PalletLynxLogo from "assets/images/Pallet Lynx.png";
import error from "assets/images/error.jpg";
import { useSoftUIController } from "context";
import { debounce, initial } from "lodash";
import PropTypes from "prop-types";
import { memo, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { emit, useNativeMessage } from "react-native-react-bridge/lib/web";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  isStaleCartError,
  clearStaleCartStorage,
  showStaleCartDialog,
} from "../../../utils/staleCartHandler";
// staleCartHandler helpers above are retained; error handling for add-to-cart
// paths is now centralised in useAddToCart but other callers in this file may still need them.
import packageJson from "../../../../../package.json";
import { customEventTrigger } from "../../../analytics";
import PosActivityLoader from "../../../components/PosActivityLoader/PosActivityLoader";
import {
  FilterProduct,
  activeSessionDay,
  atRefresh,
// customerSearch,
  customerSearchV2Api,
  getActiveSession,
  getAllOrgPaymentMethods,
  getLocDetailByLongAndLat,
  getRetailDetails,
  healthCheck,
  logoutSession,
  removeLoyalty,
  rtValidation,
  getManagers,
  validateManagerPin,
} from "../../../config/Services";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
  setInLocalStorage,
} from "../../../utils/localStorageHelpers";
import { withSwalKeyboardNav } from "../../../utils/swalKeyboardNav";
import Menu from "../product/all-products/Menu";
import {
  addingProductTime,
  changePrevAddedTime,
  incrementScannedProduct,
  setTotalProducts,
} from "../product/all-products/redux/Actions/eventTracker";
import {
  getFullState,
  getScannedProduct,
  getTotalProducts,
} from "../product/all-products/redux/Reducers/eventTrackerReducer";
import {
  getCustomerText,
  getDeviceType,
  getMobilePos,
  getOdsNotif,
  getOrderText,
  getSearchOpen,
} from "../product/all-products/redux/Reducers/paginationReducer";
import { checkGtinType, checkUnitType } from "../product/all-products/utils/cartUtils";
import { useSnackbar } from "../product/hooks/SnackbarProvider";
import { useAddToCart } from "../product/hooks/useAddToCart";
import useWeighingItemModal from "../product/hooks/useWeighingItemModal";
import useGetDevice from "../product/hooks/useGetDevice";
import usePrint from "../product/hooks/usePrint";
import { KeyboardShortcuts } from "../product/settings/components/KeyboardShortcut";
import { E404Page } from "../error-page/err";
import BatchSelectionModal from "../product/all-products/components/twoWaykeyboardPaymentPage/components/batch-popup/index";
import {
  customerFilter,
  focusBarcode,
  openProductDetailsSearch,
  odsFilter,
  orderFilter,
  returnFilter,
  scanEnd,
  searchTextRes,
  searchTextRespaymnet,
  selectBatchStat,
  setAppDrawer,
  setFocus,
  setLoading,
  setOdsNotif,
} from "../product/all-products/redux/Actions/paginationActions";
import { useDisableNumberInputScroll } from "../product/hooks/useDisableInputScroll";
import useIdleChecker from "../product/hooks/useIdleChecker";
// import useAppBootstrap from "./../product/hooks/useAppBootstrap";
import { CartTableBar } from "./components/CartTableBar/index";
import { NoDayStartedModalPopup } from "./components/noDayStarted/index";
import { ProductDetailsPage } from "./components/productDetail";
import personIcon from "../../../assets/images/person.png";
import "./index.css";

import { Peripherals } from "../product/settings/components/Peripherals";
import {
  addmanagerpin,
  addmanageruidx,
} from "../product/all-products/redux/Actions/SessionActions";
import { getmangerPin, getmangeruidx } from "../product/all-products/redux/Reducers/sessionReducer";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import StyledSelect from "../product/all-products/components/custom/StyledSelect";
import NetworkConfig from "../product/settings/components/networkConfig";
import { DisplayModeSettings } from "../product/settings/components/DisplaySettings";
import CreateMenuSearchbar from "../product/settings/components/CreateMenu/CreateMenuSearchbar";
import ExpenseHeader from "../expenses/components/expenseHeader";
import InventoryIcon from "@mui/icons-material/Inventory";
import PosCustomIcon from "../../../customComponents/PosCustomIcon/PosCustomIcon";
import { ArrowsPointingOutIcon, Bars3Icon } from "@heroicons/react/20/solid";
import {
  fetchAllOrdersAndSlots,
  startOrderPolling,
  subscribeOrderUpdates,
} from "../../../utils/odsArchitecture/orderPollingService";
import { handleOrderNotification } from "../../../utils/notificationSystem/orderNotification";
import {
  buildOrderNotifs,
  mapWaiterTasksToNotifs,
  sortByRecent,
  TASK_TYPE_ICONS,
  TASK_TYPE_COLORS,
} from "../../../utils/notificationSystem/notificationMappers";
import {
  startTableTaskPolling,
  stopTableTaskPolling,
  subscribeTableTasks,
} from "../../../utils/notificationSystem/tableTaskPollingService";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import FloatingOrderIsland from "../FloatingOrderIsland/FloatingOrderIsland";
import { usePrinterAgentStatus } from "../../../context/PrinterAgentContext";
import { useKitchenNotifications } from "../../../context/KitchenNotificationsContext";
import MenuAvailabilityDrawer from "../table-layout/components/MenuAvailabilityDrawer";
import WeatherWidget from "./components/WeatherWidget/WeatherWidget";
import NewNotificationDrawer from "./components/NewNotificationDrawer";
import HoldOrderDrawer from "./components/HoldOrderDrawer";
import HelpAndSupportDrawer from "./components/helpAndSupportDrawer/helpAndSupportDrawer";
import SessionClosingDrawer from "./components/SessionClosingDrawer/SessionCLosingDrawer";

import { unlockAudio } from "../../../utils/notificationSystem/orderAlertAudio";
import {
  startNotificationPolling,
  stopNotificationPolling,
  subscribeOrderNotification,
} from "../../../utils/notificationSystem/orderNotificationPollingService";
import { ReplayOutlined } from "@mui/icons-material";
import LogisticsDrawer from "./components/logisticsDrawer/logisticsDrawer";
import ExpenseDrawer from "./components/ExpenseDrawer/ExpenseDrawer";
import SessionClosingDrawerV2 from "./components/SessionClosingDrawerV2/SessionClosingDrawerV2";
import CashDrawerModal from "../product/all-products/components/CashDrawerModal/CashDrawerModal";
import { Account } from "../product/settings/components/Account";

const drawerWidth = 85;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  })
);

const updateSwal = Swal.mixin({
  customClass: {
    confirmButton: "button button-success",
    cancelButton: "button button-error",
    container: "close-session-swal-container",
  },
  buttonsStyling: false,
});

// ─── Page title map ──────────────────────────────────────────────────────────
const PAGE_LABEL_MAP = {
  homepage: "Home",
  "all-products": "Products",
  ProductsPage: "Products",
  keyboard: "Keyboard POS",
  paymentpage: "Cart",
  twoWay: "Cart",
  coupons: "Coupons",
  points: "Loyalty Points",
  customertable: "Customers",
  orderstable: "Orders",
  returntable: "Returns",
  holdorderpage: "Hold Orders",
  delivery: "Delivery",
  "delivery-restaurant": "Delivery",
  "kitchen-display": "Kitchen Display",
  stockAdjustment: "Inventory",
  logisticsOrder: "Logistics",
  "table-layout": "Table Layout",
  "session-listing": "Sessions",
  "start-day": "Start Day",
  opening: "Opening",
  closing: "Closing",
  expenseslistpage: "Expenses",
  settings: "Settings",
  "operations-menu": "Menu",
};

/**
 * Notification center registry
 * ----------------------------
 * The bell button and RestaurantNotificationCenter can live in different parts
 * of the tree, and there can briefly be more than one instance mounted (route
 * transitions). Each instance registers an "opener" here keyed by id; the bell
 * calls `openActiveNotificationDrawer()` which opens the most recently mounted
 * one. This avoids prop-drilling the drawer's open-setter up to the bell.
 */
let notificationCenterInstanceCounter = 0;
const notificationCenterInstances = new Set();
const notificationCenterOpeners = new Map();

const getActiveNotificationCenterId = () => {
  const ids = Array.from(notificationCenterInstances);
  return ids[ids.length - 1] || null;
};

const openActiveNotificationDrawer = () => {
  const activeId = getActiveNotificationCenterId();
  notificationCenterOpeners.get(activeId)?.();
};

// ─── Dynamic island visuals ──────────────────────────────────────────────────
const NOTIF_ACCENT = {
  NEW_ORDER: "#3b82f6", // blue
  KITCHEN_ORDER: "#f0a54a",
  ORDER_ACCEPTED: "#0ea5e9", // sky
  ORDER_PREPARING: "#f59e0b", // amber
  ORDER_READY: "#22c55e", // green
  OUT_FOR_DELIVERY: "#6366f1", // indigo
  PAYMENT_RECEIVED: "#16a34a", // green
  NEW_DELIVERY: "#8b5cf6", // violet
};

const getNotifAccent = (notif) => {
  if (notif?.type === "TABLE_TASK") {
    return TASK_TYPE_COLORS[notif.taskAction] || TASK_TYPE_COLORS.DEFAULT;
  }
  return NOTIF_ACCENT[notif?.type] || NOTIF_ACCENT.ORDER_READY;
};

// Inline lucide-style glyphs so the island matches the reference exactly. Stroke
// uses currentColor, so the accent is applied via the wrapper's `color`.
const IslandGlyph = ({ notif, className }) => {
  const type = notif?.type;
  if (type === "TABLE_TASK") {
    return (
      <span className={className} style={{ lineHeight: 1 }}>
        {TASK_TYPE_ICONS[notif.taskAction] || TASK_TYPE_ICONS.DEFAULT}
      </span>
    );
  }
  const common = {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className,
  };
  if (type === "PAYMENT_RECEIVED") {
    return (
      <svg {...common}>
        <rect width="20" height="14" x="2" y="5" rx="2" />
        <line x1="2" x2="22" y1="10" y2="10" />
      </svg>
    );
  }
  if (type === "KITCHEN_ORDER") {
    return (
      <svg {...common}>
        <path d="M4 10h16l-1.5 10h-13L4 10Z" />
        <path d="M8 10a4 4 0 0 1 8 0" />
        <path d="M8 14h.01M12 14h.01M16 14h.01" />
      </svg>
    );
  }
  if (type === "NEW_DELIVERY" || type === "OUT_FOR_DELIVERY") {
    return (
      <svg {...common}>
        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
        <path d="M15 18H9" />
        <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
        <circle cx="17" cy="18" r="2" />
        <circle cx="7" cy="18" r="2" />
      </svg>
    );
  }
  if (type === "NEW_ORDER") {
    // package / new order
    return (
      <svg {...common}>
        <path d="m7.5 4.27 9 5.15" />
        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
        <path d="m3.3 7 8.7 5 8.7-5" />
        <path d="M12 22V12" />
      </svg>
    );
  }
  if (type === "ORDER_ACCEPTED") {
    // check circle
    return (
      <svg {...common}>
        <path d="M21.801 10A10 10 0 1 1 17 3.335" />
        <path d="m9 11 3 3L22 4" />
      </svg>
    );
  }
  if (type === "ORDER_PREPARING") {
    // clock
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    );
  }
  // default → chef hat (Order Ready)
  return (
    <svg {...common}>
      <path d="M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z" />
      <path d="M6 17h12" />
    </svg>
  );
};

IslandGlyph.propTypes = {
  notif: PropTypes.object,
  className: PropTypes.string,
};

const notifLabel = (notif) => {
  if (!notif) return "No new notifications";
  const tag = notif.tags?.[0];
  return tag ? `${notif.title}: ${tag}` : notif.title;
};

const islandTimeAgo = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const diff = Math.floor((Date.now() - d.getTime()) / 60000);
  if (Number.isNaN(diff)) return "";
  if (diff < 1) return "Just now";
  if (diff < 60) return `${diff}m ago`;
  const h = Math.floor(diff / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

/**
 * RestaurantNotificationCenter
 * ----------------------------
 * Owns the navbar notification feature for ALL retail types (name is historical):
 *   1. The Apple-style "dynamic island" pill in the navbar centre — auto-cycles
 *      the most recent notifications and morphs open into a "Live Updates" panel.
 *   2. The full NewNotificationDrawer (opened by the bell).
 *
 * Data sources (no polling is owned by render — see services so re-mounts don't
 * re-fetch):
 *   - Orders: the existing ODS aggregator (20s, orderNotificationPollingService)
 *     only tells us WHEN something changed; on a new order we pull the real list
 *     via getAllOrderlist (subscribeOrderUpdates → orderData). orderData is then
 *     mapped to notifications by buildOrderNotifs.
 *   - Table tasks (restaurant only): tableTaskPollingService (singleton, 3 min).
 *
 * Read state lives here (persisted to localStorage `islandReadIds`) and is passed
 * down to the drawer, so the island red dot and the drawer agree. The badge/dot
 * reflect UNREAD only; ids are status-aware so a status change re-flags as unread.
 */
const RestaurantNotificationCenter = memo(function RestaurantNotificationCenter({
  retailType,
  dispatchSearch,
  onCountChange,
}) {
  const kitchen = useKitchenNotifications();
  const kitchenNotifs = kitchen?.notifications || [];
  const kitchenIncomingJobIds = kitchen?.incomingJobIds || [];
  const kitchenArrivalVersion = kitchen?.arrivalVersion;
  const [preferredKitchenNotifId, setPreferredKitchenNotifId] = useState(null);
  const [kitchenArrivalAnimation, setKitchenArrivalAnimation] = useState(false);
  const seenKitchenArrivalVersion = useRef({ initialized: false, version: undefined });
  const kitchenArrivalTimer = useRef(null);
  const instanceIdRef = useRef(null);
  const [currentNotifIndex, setCurrentNotifIndex] = useState(0);
  const [notifVisible, setNotifVisible] = useState(true);
  const [notifDrawerOpen, setNotifDrawerOpen] = useState(false);
  const [panelOpen, setPanelOpen] = useState(false);
  const islandRef = useRef(null);
  const [orderData, setOrderData] = useState([]);
  const [waiterTasks, setWaiterTasks] = useState([]);
  // Read notifications (persisted so the red dot stays cleared across re-mounts).
  const [readIds, setReadIds] = useState(() => {
    try {
      return new Set(JSON.parse(localStorage.getItem("islandReadIds") || "[]"));
    } catch {
      return new Set();
    }
  });

  const isRestaurant = retailType === "RESTAURANT";

  if (!instanceIdRef.current) {
    notificationCenterInstanceCounter += 1;
    instanceIdRef.current = notificationCenterInstanceCounter;
  }

  const persistReadIds = (set) => {
    try {
      localStorage.setItem("islandReadIds", JSON.stringify([...set].slice(-300)));
    } catch {
      /* ignore quota errors */
    }
  };

  const markRead = useCallback((id) => {
    if (!id) return;
    setReadIds((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set([...prev, id].slice(-300));
      persistReadIds(next);
      return next;
    });
  }, []);

  const markAllRead = useCallback((ids = []) => {
    setReadIds((prev) => {
      const next = new Set([...prev, ...ids.filter(Boolean)].slice(-300));
      persistReadIds(next);
      return next;
    });
  }, []);

  // Unified, most-recent-first notification list feeding both the dynamic island
  // and the bell count. Order notifications apply to every retail type; waiter
  // table tasks are restaurant-only.
  const islandNotifs = useMemo(() => {
    const orderNotifs = buildOrderNotifs(orderData || []);
    const taskNotifs = isRestaurant ? mapWaiterTasksToNotifs(waiterTasks) : [];
    const sorted = sortByRecent([...orderNotifs, ...taskNotifs, ...kitchenNotifs]);
    if (!preferredKitchenNotifId) return sorted;
    const preferredIndex = sorted.findIndex((n) => n.id === preferredKitchenNotifId);
    if (preferredIndex <= 0) return sorted;
    return [sorted[preferredIndex], ...sorted.slice(0, preferredIndex), ...sorted.slice(preferredIndex + 1)];
  }, [orderData, waiterTasks, isRestaurant, kitchenNotifs, preferredKitchenNotifId]);

  // The provider owns KDS detection and sound. Only a version transition is a
  // new-arrival signal; a remount starts from the current version and stays quiet.
  useEffect(() => {
    if (!seenKitchenArrivalVersion.current.initialized) {
      seenKitchenArrivalVersion.current = { initialized: true, version: kitchenArrivalVersion };
      return;
    }
    if (seenKitchenArrivalVersion.current.version === kitchenArrivalVersion) return;
    const incoming = new Set((kitchenIncomingJobIds || []).map(String));
    const newestIncoming = sortByRecent(
      kitchenNotifs.filter((n) => incoming.has(String(n.jobId)) || incoming.has(String(n.id)))
    )[0];
    if (!newestIncoming) return;
    seenKitchenArrivalVersion.current.version = kitchenArrivalVersion;
    setPreferredKitchenNotifId(newestIncoming.id);
    setCurrentNotifIndex(0);
    setKitchenArrivalAnimation(true);
    if (kitchenArrivalTimer.current) clearTimeout(kitchenArrivalTimer.current);
    kitchenArrivalTimer.current = setTimeout(() => setKitchenArrivalAnimation(false), 900);
  }, [kitchenArrivalVersion, kitchenIncomingJobIds, kitchenNotifs]);

  useEffect(
    () => () => {
      if (kitchenArrivalTimer.current) clearTimeout(kitchenArrivalTimer.current);
    },
    []
  );

  const notifCount = islandNotifs.length;
  // The red dot / badge reflect UNREAD notifications only.
  const unreadCount = useMemo(
    () => islandNotifs.reduce((n, x) => n + (readIds.has(x.id) ? 0 : 1), 0),
    [islandNotifs, readIds]
  );

  useEffect(() => {
    const instanceId = instanceIdRef.current;
    notificationCenterInstances.add(instanceId);
    notificationCenterOpeners.set(instanceId, () => setNotifDrawerOpen(true));

    return () => {
      notificationCenterInstances.delete(instanceId);
      notificationCenterOpeners.delete(instanceId);
    };
  }, []);

  useEffect(() => {
    onCountChange?.(unreadCount);
  }, [unreadCount, onCountChange]);

  // Order pipeline. Two distinct subscriptions, by design:
  //  (a) subscribeOrderNotification = the 20s ODS aggregator. It's a cheap signal
  //      (counts/flags only) — we use it for the existing buzzer/blink alert and
  //      as a trigger to refresh the real list when a new order arrives.
  //  (b) subscribeOrderUpdates = the actual order list (getAllOrderlist). This is
  //      what the island/drawer render. We DON'T add a separate timer for it; we
  //      reuse the aggregator's "new order" signal to pull it, plus one fetch on
  //      mount for the initial paint.
  useEffect(() => {
    const unsubscribeNotif = subscribeOrderNotification(({ hasNewOrder, hasCreatedOrders }) => {
      handleOrderNotification({
        retailType,
        isDeliveryScreen: false,
        hasNewOrder,
        hasCreatedOrders,
        setBlinkIcon: (value) => dispatchSearch(setOdsNotif(value)),
      });

      // The delivery screen owns its own refresh; don't double-fetch there.
      const isDeliveryScreen = window.location.pathname === "/orders";

      if (hasNewOrder && !isDeliveryScreen) {
        fetchAllOrdersAndSlots();
      }
    });

    // Capture the live order list so the island and drawer reflect real orders.
    const unsubscribeOrders = subscribeOrderUpdates((payload) => {
      setOrderData(payload?.data?.orderResponseList || []);
    });

    startNotificationPolling(); // shared singleton — safe to call repeatedly
    fetchAllOrdersAndSlots(); // initial paint

    return () => {
      unsubscribeNotif();
      unsubscribeOrders();
    };
  }, [dispatchSearch, retailType]);

  // Subscribe to the singleton waiter-task poller (restaurant only). The service
  // owns the timer, so re-mounts here don't trigger extra fetches.
  useEffect(() => {
    if (!isRestaurant) {
      setWaiterTasks([]);
      return;
    }

    const unsubscribe = subscribeTableTasks(setWaiterTasks);
    startTableTaskPolling();
    return () => unsubscribe();
  }, [isRestaurant]);

  useEffect(() => {
    const handleFirstInteraction = () => {
      unlockAudio();
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("keydown", handleFirstInteraction);
      window.removeEventListener("touchstart", handleFirstInteraction);
    };

    window.addEventListener("click", handleFirstInteraction);
    window.addEventListener("keydown", handleFirstInteraction);
    window.addEventListener("touchstart", handleFirstInteraction);

    return () => {
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("keydown", handleFirstInteraction);
      window.removeEventListener("touchstart", handleFirstInteraction);
    };
  }, []);

  useEffect(() => {
    const handler = () => {
      if (getActiveNotificationCenterId() !== instanceIdRef.current) return;
      setNotifDrawerOpen(true);
    };
    window.addEventListener("pos:open-notifications", handler);
    return () => window.removeEventListener("pos:open-notifications", handler);
  }, []);

  // Auto-cycle the island through active notifications, newest first.
  useEffect(() => {
    if (notifCount <= 1) {
      setCurrentNotifIndex(0);
      setNotifVisible(true);
      return;
    }

    const id = setInterval(() => {
      setNotifVisible(false);
      setTimeout(() => {
        setCurrentNotifIndex((i) => (i + 1) % notifCount);
        setNotifVisible(true);
      }, 300);
    }, 4000);

    return () => clearInterval(id);
  }, [notifCount]);

  // Close the expanded panel when clicking anywhere outside the island.
  useEffect(() => {
    if (!panelOpen) return undefined;
    const handleOutside = (e) => {
      if (islandRef.current && !islandRef.current.contains(e.target)) {
        setPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [panelOpen]);

  const activeNotif = islandNotifs[currentNotifIndex] || null;
  const islandLabel = notifLabel(activeNotif);
  const activeAccent = getNotifAccent(activeNotif);
  const isExpanded = panelOpen && (notifCount > 0 || kitchen?.error || kitchen?.needsInteraction);

  return (
    <>
      <div className="topbar-island" ref={islandRef}>
        <div
          className={`island-shell ${isExpanded ? "expanded" : ""} ${
            kitchenArrivalAnimation ? "kitchen-arrival" : ""
          }`}
          onClick={() =>
            (notifCount > 0 || kitchen?.error || kitchen?.needsInteraction) &&
            setPanelOpen((p) => !p)
          }
          role="group"
          tabIndex={0}
          aria-expanded={isExpanded}
          aria-label={notifCount ? `Notifications, ${unreadCount} unread` : "Notifications"}
          onKeyDown={(event) => {
            if ((event.key === "Enter" || event.key === " ") &&
                (notifCount > 0 || kitchen?.error || kitchen?.needsInteraction)) {
              event.preventDefault();
              setPanelOpen((p) => !p);
            }
          }}
        >
          {/* ── Collapsed pill ── */}
          <div className="island-compact">
            <div className="island-compact-left">
              <div className="island-icon" style={{ color: activeAccent }}>
                <IslandGlyph notif={activeNotif} className="island-glyph-sm" />
              </div>
              <span
                className={`island-compact-label ${
                  notifVisible ? "notif-slide-in" : "notif-slide-out"
                }`}
              >
                {islandLabel}
              </span>
            </div>
            {/* Red dot + count only while there are UNREAD notifications */}
            {unreadCount > 0 && (
              <div className={`island-badge-circle ${kitchenArrivalAnimation ? "kitchen-arrival-target" : ""}`}>
                <span className="island-badge-dot" />
                <span className="island-badge-num">{unreadCount}</span>
              </div>
            )}
          </div>

          {/* ── Expanded "Live Updates" card (morphs from the pill) ── */}
          <div className="island-expand-wrap">
            <div className="island-expand-inner" onClick={(e) => e.stopPropagation()}>
              <div className="island-panel-header">
                <span className="island-panel-title">Live Updates</span>
                <span className="island-panel-count">
                  <b>{unreadCount}</b> Active
                </span>
              </div>
              <div className="island-panel-list">
                {kitchen?.needsInteraction && (
                  <div className="kitchen-sound-prompt">
                    <span>Enable sound alerts for new kitchen orders</span>
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        kitchen.enableSound?.();
                      }}
                    >
                      Enable sound
                    </button>
                  </div>
                )}
                {kitchen?.error && (
                  <div className="kitchen-feed-error" role="alert">
                    <span>Kitchen updates couldn’t be loaded.</span>
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        kitchen.refresh?.();
                      }}
                    >
                      Retry
                    </button>
                  </div>
                )}
                {islandNotifs.slice(0, 6).map((n) => {
                  const accent = getNotifAccent(n);
                  const isRead = readIds.has(n.id);
                  return (
                    <div
                      key={n.id}
                      className={`island-panel-item ${isRead ? "read" : ""}`}
                      onClick={() => markRead(n.id)}
                    >
                      <span className={`island-item-dot ${isRead ? "hidden" : ""}`} />
                      <div className="island-panel-icon" style={{ color: accent }}>
                        <IslandGlyph notif={n} className="island-glyph-md" />
                      </div>
                      <div className="island-panel-content">
                        <p className="island-panel-item-title">{notifLabel(n)}</p>
                        <p className="island-panel-item-time">{islandTimeAgo(n.createdAt)}</p>
                      </div>
                      <button type="button" className="island-panel-chevron-btn" tabIndex={-1}>
                        <ChevronRightIcon style={{ fontSize: "1rem" }} />
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <NewNotificationDrawer
        open={notifDrawerOpen}
        onClose={() => setNotifDrawerOpen(false)}
        orders={orderData || []}
        retailType={retailType}
        waiterTasks={waiterTasks}
        readIds={readIds}
        onMarkRead={markRead}
        onMarkAllRead={markAllRead}
        additionalKitchenNotifications={kitchenNotifs}
      />
    </>
  );
});

RestaurantNotificationCenter.propTypes = {
  retailType: PropTypes.string,
  dispatchSearch: PropTypes.func,
  onCountChange: PropTypes.func,
};

const FloorCapacityPopup = memo(function FloorCapacityPopup({ stats, anchorRef, onClose }) {
  const [activeView, setActiveView] = useState("seats");
  const popupRef = useRef(null);

  const occupiedTables = stats?.occupiedTables ?? 0;
  const totalTables = stats?.totalTables ?? 0;
  const occupiedSeats = stats?.occupiedSeats ?? 0;
  const totalSeats = stats?.totalSeats ?? 0;
  const kotCount = stats?.kotCount ?? 0;

  const pct =
    activeView === "seats"
      ? totalSeats > 0
        ? Math.round((occupiedSeats / totalSeats) * 100)
        : 0
      : totalTables > 0
      ? Math.round((occupiedTables / totalTables) * 100)
      : 0;

  useEffect(() => {
    const handleClick = (e) => {
      if (anchorRef?.current?.contains(e.target)) return;
      if (popupRef?.current?.contains(e.target)) return;
      onClose();
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [anchorRef, onClose]);

  return (
    <div ref={popupRef} className="fcp-popup">
      <div className="fcp-header">
        <div className="fcp-header-left">
          <span className="fcp-label">LIVE CAPACITY</span>
          <span className="fcp-title">Floor occupancy</span>
        </div>
        <div className="fcp-pct-badge">
          <span className="fcp-pct-now">NOW</span>
          <span className="fcp-pct-value">{pct}%</span>
        </div>
      </div>

      <div className="fcp-bar-track">
        <div className="fcp-bar-fill" style={{ width: `${pct}%` }} />
      </div>

      <div className="fcp-stats-row">
        <div className="fcp-stat-box">
          <span className="fcp-stat-label">SEATS</span>
          <span className="fcp-stat-value">
            {occupiedSeats}/{totalSeats}
          </span>
        </div>
        <div className="fcp-stat-box">
          <span className="fcp-stat-label">TABLES</span>
          <span className="fcp-stat-value">
            {occupiedTables}/{totalTables}
          </span>
        </div>
        <div className="fcp-stat-box">
          <span className="fcp-stat-label">KOT&apos;S</span>
          <span className="fcp-stat-value">{kotCount}</span>
        </div>
      </div>

      <div className="fcp-toggle-row">
        <button
          className={`fcp-toggle-btn${activeView === "seats" ? " active" : ""}`}
          onClick={() => setActiveView("seats")}
        >
          Seats view
        </button>
        <button
          className={`fcp-toggle-btn${activeView === "tables" ? " active" : ""}`}
          onClick={() => setActiveView("tables")}
        >
          Tables view
        </button>
      </div>
    </div>
  );
});

const TopNavbar = memo(function TopNavbar({
  navigationDisabled = false,
  pathname,
  color,
  retailType,
  currentPageLabel,
  handleRedirect,
  tableLayoutRefetch,
  tableLayoutStats,
  cartRefetch,
  inputRefScan,
  setPlaceholderText,
  path,
  handleSearchChange,
  searchInputValue,
  focus,
  dispatchSearch,
  clearSearch,
  searchText,
  increseScreen,
  setHelpAndSupportDrawerOpen,
  handleOpen,
  firstName,
  showCamera,
  setShowCamera,
  cameraStyle,
  navigate,
  changeColorFun,
}) {
  const [showStatsPopup, setShowStatsPopup] = useState(false);
  const statsAnchorRef = useRef(null);
  const [uniOpen, setUniOpen] = useState(false);
  const [uniQuery, setUniQuery] = useState("");
  const [drawerModalOpen, setDrawerModalOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0);
  const uniRef = useRef(null);
  const showSnackbar = useSnackbar();
  const { openDrawer } = usePrint();

  // Global search is functional on Order History, Returns, and KDS; everywhere
  // else it still shows "coming soon".
  const orderAggTab = useSelector((state) => state.pagination.orderAggTab);
  const orderText = useSelector((state) => state.pagination.order_text);
  const returnText = useSelector((state) => state.pagination.return_text);
  const odsText = useSelector((state) => state.pagination.ods_text);
  const isOrderAggsPage = pathname === "/orders" || pathname === "/order-aggs";
  const isOrderHistorySearch = isOrderAggsPage && orderAggTab === "Order History";
  const isReturnsSearch = isOrderAggsPage && orderAggTab === "Returns";
  const isOdsSearch = isOrderAggsPage && orderAggTab === "Online Orders";
  const isKdsSearch =
    pathname === "/products/kitchen-display" ||
    (isOrderAggsPage && orderAggTab === "Kitchen Display (KDS)");
  // Both tabs use the same compact inline popover (no "coming soon" backdrop).
  const isInlineSearch = isOrderHistorySearch || isReturnsSearch || isKdsSearch || isOdsSearch;
  const [kdsSearchText, setKdsSearchText] = useState("");

  const debouncedOrderSearch = useMemo(
    () => debounce((val) => dispatchSearch(orderFilter(val)), 400),
    [dispatchSearch]
  );

  const debouncedReturnSearch = useMemo(
    () => debounce((val) => dispatchSearch(returnFilter(val)), 400),
    [dispatchSearch]
  );

  const debouncedOdsSearch = useMemo(
    () => debounce((val) => dispatchSearch(odsFilter(val)), 400),
    [dispatchSearch]
  );

  const emitKdsSearch = useCallback((val) => {
    window.dispatchEvent(new CustomEvent("pos:kds-search", { detail: { query: val } }));
  }, []);

  // Cancel any pending debounced dispatch on unmount so we don't set filter text
  // after the navbar is gone.
  useEffect(
    () => () => {
      debouncedOrderSearch.cancel();
      debouncedReturnSearch.cancel();
      debouncedOdsSearch.cancel();
    },
    [debouncedOrderSearch, debouncedReturnSearch, debouncedOdsSearch]
  );

  const closeSearch = useCallback(() => {
    setUniOpen(false);
    setUniQuery("");
  }, []);

  useEffect(() => {
    if (!isKdsSearch) {
      setKdsSearchText("");
    }
  }, [isKdsSearch]);

  // Seed the input with the active filter when reopening the search.
  useEffect(() => {
    if (!uniOpen) return;
    if (isReturnsSearch && returnText) {
      setUniQuery(returnText);
    } else if (isOrderHistorySearch && orderText) {
      setUniQuery(orderText);
    } else if (isOdsSearch && odsText) {
      setUniQuery(odsText);
    } else if (isKdsSearch) {
      setUniQuery(kdsSearchText);
    }
  }, [
    uniOpen,
    isReturnsSearch,
    returnText,
    isOrderHistorySearch,
    orderText,
    isOdsSearch,
    odsText,
    isKdsSearch,
    kdsSearchText,
  ]);

  // The inline popover has no backdrop, so close it on an outside click.
  useEffect(() => {
    if (!uniOpen || !isInlineSearch) return;
    const onDown = (e) => {
      if (uniRef.current && !uniRef.current.contains(e.target)) {
        setUniOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [uniOpen, isInlineSearch]);

  const handleUniChange = (e) => {
    const val = e.target.value;
    setUniQuery(val);
    if (isReturnsSearch) {
      debouncedReturnSearch(val);
    } else if (isOrderHistorySearch) {
      debouncedOrderSearch(val);
    } else if (isOdsSearch) {
      debouncedOdsSearch(val);
    } else if (isKdsSearch) {
      setKdsSearchText(val);
      emitKdsSearch(val);
    }
  };

  const clearUniQuery = () => {
    setUniQuery("");
    if (isReturnsSearch) {
      debouncedReturnSearch.cancel();
      dispatchSearch(returnFilter(""));
    } else if (isOrderHistorySearch) {
      debouncedOrderSearch.cancel();
      dispatchSearch(orderFilter(""));
    } else if (isOdsSearch) {
      debouncedOdsSearch.cancel();
      dispatchSearch(odsFilter(""));
    } else if (isKdsSearch) {
      setKdsSearchText("");
      emitKdsSearch("");
    }
  };

  // Enter applies the search immediately and closes the drawer to reveal the
  // filtered table behind it (the filter text persists in redux).
  const submitInlineSearch = () => {
    if (isReturnsSearch) {
      debouncedReturnSearch.cancel();
      dispatchSearch(returnFilter(uniQuery));
    } else if (isOrderHistorySearch) {
      debouncedOrderSearch.cancel();
      dispatchSearch(orderFilter(uniQuery));
    } else if (isOdsSearch) {
      debouncedOdsSearch.cancel();
      dispatchSearch(odsFilter(uniQuery));
    } else if (isKdsSearch) {
      setKdsSearchText(uniQuery);
      emitKdsSearch(uniQuery);
    }
    closeSearch();
  };

  // Backtick opens the search modal (preserves the scan-to-search workflow)
  useEffect(() => {
    if (navigationDisabled && !isKdsSearch) return;
    const onKey = (e) => {
      if (e.key !== "`") return;
      const tag = document.activeElement?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;
      setUniOpen(true);
    };
    document.addEventListener("keyup", onKey);
    return () => document.removeEventListener("keyup", onKey);
  }, [navigationDisabled, isKdsSearch]);

  return (
    <AppBar
      position="fixed"
      open={false}
      className={pathname === "/grocery/cart" ? "newpayment-posNabar" : "posNavbar"}
    >
      <div className={`topbar-brand-row ${color === "dark" ? "dark" : ""}`}>
        <div
          className="topbar-brand"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/products/operations-menu")}
        >
          <div className="topbar-logo-wrap">
            <img className="topbar-brand-logo" src={PalletLynxLogo} alt="Pallet Lynx" />
          </div>
          <div className="topbar-brand-text">
            <span className="topbar-brand-name">Pallet Lynx</span>
            <span className="topbar-brand-sub">POS System</span>
          </div>
        </div>

        <div className="topbar-center">
          {navigationDisabled ? (
            <div className="topbar-notif-chip">
              <div className="topbar-notif-left">
                <div className="topbar-notif-icon-wrap">
                  <RestaurantOutlinedIcon sx={{ fontSize: "0.95rem", color: "#16a34a" }} />
                </div>
                <span className="topbar-notif-text">Order Ready</span>
              </div>
            </div>
          ) : <RestaurantNotificationCenter
            retailType={retailType}
            dispatchSearch={dispatchSearch}
            onCountChange={setNotifCount}
          />}
        </div>

        <div className="topbar-right-actions">
          <div
            ref={uniRef}
            className="topbar-search-container"
            style={{ position: "relative", display: "flex", alignItems: "center", gap: "12px" }}
          >
            <button
              type="button"
              className="topbar-action-btn"
              title="Search (shortcut: `)"
              data-kds-navigation-enabled={navigationDisabled ? "true" : undefined}
              aria-disabled={navigationDisabled ? false : undefined}
              onClick={() => {
                if (uniOpen) {
                  setUniOpen(false);
                } else {
                  setUniOpen(true);
                }
              }}
            >
              <SearchIcon />
            </button>

            <button
              type="button"
              className="topbar-action-btn topbar-theme-toggle-btn"
              data-testid="button-header-theme-toggle"
              title={color === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              onClick={changeColorFun}
            >
              {color === "dark" ? (
                /* Sun — shown in dark mode, click to go light */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="4" />
                  <line x1="12" y1="2" x2="12" y2="5" />
                  <line x1="12" y1="19" x2="12" y2="22" />
                  <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" />
                  <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" />
                  <line x1="2" y1="12" x2="5" y2="12" />
                  <line x1="19" y1="12" x2="22" y2="12" />
                  <line x1="4.22" y1="19.78" x2="6.34" y2="17.66" />
                  <line x1="17.66" y1="6.34" x2="19.78" y2="4.22" />
                </svg>
              ) : (
                /* Moon — shown in light mode, click to go dark */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  stroke="none"
                >
                  <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z" />
                </svg>
              )}
            </button>

            {uniOpen && isInlineSearch && (
              // Order History / Returns: compact inline search anchored under the
              // icon so it doesn't dim the page. Results update live as you type.
              <div
                className="topbar-search-popover"
                data-kds-navigation-enabled={navigationDisabled ? "true" : undefined}
                aria-disabled={navigationDisabled ? false : undefined}
                role="dialog"
                aria-label={
                  isReturnsSearch
                    ? "Search returns"
                    : isKdsSearch
                    ? "Search KDS orders"
                    : isOdsSearch
                    ? "Search online orders"
                    : "Search orders"
                }
              >
                <div className="topbar-search-wrap topbar-search-wrap--popover">
                  <SearchIcon className="topbar-search-icon" />
                  <input
                    ref={inputRefScan}
                    id="search-input"
                    className="topbar-search-input"
                    placeholder={
                      isReturnsSearch
                        ? "Search By Order Id, Customer Number"
                        : isKdsSearch
                        ? "Search by order"
                        : isOdsSearch
                        ? "Search By Order Id, Customer Number"
                        : "Search By Order Id, Invoice Id, Customer Number"
                    }
                    autoFocus
                    value={uniQuery}
                    onChange={handleUniChange}
                    onKeyDown={(e) => {
                      if (e.key === "Escape") closeSearch();
                      if (e.key === "Enter") submitInlineSearch();
                    }}
                  />
                  {!!uniQuery && (
                    <ClearIcon className="topbar-search-clear" onClick={clearUniQuery} />
                  )}
                </div>
              </div>
            )}

            {uniOpen && !isInlineSearch && (
              <>
                <div className="topbar-search-backdrop" onMouseDown={closeSearch} />
                <div className="topbar-search-drawer" role="dialog" aria-label="Search">
                  <div className="topbar-search-drawer-header">
                    <div className="topbar-search-wrap topbar-search-wrap--modal">
                      <SearchIcon className="topbar-search-icon" />
                      <input
                        ref={inputRefScan}
                        id="search-input"
                        className="topbar-search-input"
                        placeholder="Search with barcode or product name"
                        autoFocus
                        value={uniQuery}
                        onChange={handleUniChange}
                        onKeyDown={(e) => {
                          if (e.key === "Escape") closeSearch();
                        }}
                      />
                      {!!uniQuery && (
                        <ClearIcon className="topbar-search-clear" onClick={clearUniQuery} />
                      )}
                    </div>
                    <button
                      type="button"
                      className="topbar-search-close"
                      title="Close"
                      onClick={closeSearch}
                    >
                      <CloseIcon style={{ fontSize: "1.25rem" }} />
                    </button>
                  </div>

                  <div className="topbar-search-body">
                    <div className="topbar-search-comingsoon">
                      <span className="topbar-search-comingsoon-badge">Coming soon</span>
                      <p className="topbar-search-comingsoon-text">
                        Global search feature is coming soon.
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div
            className="topbar-action-btn"
            data-kds-navigation-enabled={navigationDisabled ? "true" : undefined}
            aria-disabled={navigationDisabled ? false : undefined}
            onClick={() => {
              if (isKdsSearch) {
                window.dispatchEvent(new CustomEvent("pos:kds-refresh"));
                return;
              }
              tableLayoutRefetch?.();
              cartRefetch?.();
            }}
            title="Refresh"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-rotate-ccw w-5 h-5"
              aria-hidden="true"
            >
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
              <path d="M3 3v5h5"></path>
            </svg>
          </div>

          {tableLayoutStats && (
            <div style={{ position: "relative" }}>
              <div
                ref={statsAnchorRef}
                className={`topbar-action-btn${showStatsPopup ? " topbar-action-btn--active" : ""}`}
                onClick={() => setShowStatsPopup((p) => !p)}
                title="Floor capacity"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="20" x2="18" y2="10" />
                  <line x1="12" y1="20" x2="12" y2="4" />
                  <line x1="6" y1="20" x2="6" y2="14" />
                </svg>
              </div>
              {showStatsPopup && (
                <FloorCapacityPopup
                  stats={tableLayoutStats}
                  anchorRef={statsAnchorRef}
                  onClose={() => setShowStatsPopup(false)}
                />
              )}
            </div>
          )}

          {/* Notification bell */}
          <button
            type="button"
            className="topbar-notif-bell-wrap"
            data-testid="button-header-notifications"
            title="Notifications"
            onClick={() => openActiveNotificationDrawer()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M10.268 21a2 2 0 0 0 3.464 0" />
              <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
            </svg>
            {notifCount > 0 && <span className="topbar-notif-bell-dot" />}
          </button>

          {/* Cash Drawer */}
          <div
            className="topbar-action-btn topbar-cash-drawer-btn"
            title="Open Cash Drawer"
            onClick={() => {
              setDrawerModalOpen(true);
            }}
          >
            <span style={{ fontSize: "1rem", fontWeight: 700, lineHeight: 1 }}>₹</span>
          </div>

          <div
            className="topbar-action-btn topbar-action-desktop-only"
            onClick={increseScreen}
            title="Toggle fullscreen"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-maximize2 lucide-maximize-2 w-5 h-5"
              aria-hidden="true"
            >
              <path d="M15 3h6v6"></path>
              <path d="m21 3-7 7"></path>
              <path d="m3 21 7-7"></path>
              <path d="M9 21H3v-6"></path>
            </svg>
          </div>
          {/* 
          <div
            className="topbar-action-btn topbar-action-tablet-hide"
            title="Help & Support"
            onClick={() => setHelpAndSupportDrawerOpen(true)}
          >
            <HeadsetMicOutlinedIcon sx={{ fontSize: "1.1rem" }} />
          </div> */}

          <div
            onClick={handleOpen}
            className="topbar-action-btn"
            title="Profile"
            style={{ color: "#6b7280" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
        </div>
      </div>

      <Modal
        open={showCamera}
        onClose={() => setShowCamera(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="user-modal-wrapper-box"
      >
        <Box className="modal-box" sx={cameraStyle}>
          <h3 className="addCustomerText" style={{ margin: "0.5rem" }}>
            Scan Barcode
          </h3>
          <div style={{ position: "relative", display: "flex" }}>
            <img src={ScannerImage} alt="ScannerImage" className="scanner-image" />
          </div>
        </Box>
      </Modal>

      <Modal
        open={drawerModalOpen}
        onClose={() => setDrawerModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <CashDrawerModal setDrawerModal={setDrawerModalOpen} />
      </Modal>
    </AppBar>
  );
});

const SideNavigation = memo(function SideNavigation({
  open,
  handleRefresh,
  orgLogo,
  tabList,
  path,
  color,
  showOdsTab,
  goToLogin,
  openModal,
  handleClose,
  style,
  firstName,
  secondName,
  isMobile,
  increseScreen,
  setActiveTabComp,
  setActiveIndex,
  navigate,
  changeColorFun,
  handleLocation,
}) {
  return (
    <Drawer
      variant="permanent"
      open={open}
      sx={{ display: "none" }}
      ModalProps={{ keepMounted: true }}
      className="sideNav1"
    >
      <List className="sideList">
        <ListItem disablePadding sx={{ display: "block" }}>
          <DrawerHeader sx={{ marginTop: "0.5rem" }}>
            <Box className="wrapper-text-box" onClick={handleRefresh}>
              <img className="wrapper-logo-image" src={orgLogo || DefaultLogo} />
            </Box>
          </DrawerHeader>
          <hr className="line" />
          {tabList.map((item, index) => (
            <ListItemButton
              tabIndex={-1}
              key={`${item?.label}-${index}`}
              style={{ display: item?.hide ? "none" : "flex" }}
              className={`
                ${item?.link?.includes(path) ? "home-background-active" : "home-text-navbar-I"}
                ${!!item?.notification ? "blinking" : ""}
              `}
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={item?.redirect}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  marginRight: 0,
                }}
                className={
                  item?.link?.includes(path)
                    ? color === "dark"
                      ? "icon-active-dark"
                      : "icon-active"
                    : "icon"
                }
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  {item?.icon}
                  <ListItemText
                    className={`
                      ${item?.link?.includes(path) ? "icon-active" : "home-text-navbar"}
                      ${item?.label === "Delivery" && !showOdsTab && "delivery-tab-status"}
                    `}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </Box>
              </ListItemIcon>
            </ListItemButton>
          ))}
        </ListItem>
        <div className="cashier-wrapper-box" style={{ marginBottom: "1rem" }}>
          <hr className="line" />
          <div className="name-avatar-box" onClick={() => goToLogin("active")}>
            <LogoutIcon className="icon-color icon" />
          </div>
        </div>
      </List>

      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="user-modal-wrapper-box"
        BackdropProps={{ invisible: true }}
      >
        <Box className="modal-box profile-actions-modal" sx={style}>
          <Typography className="profile-actions-header">Profile Actions</Typography>

          <Box
            className="profile-action-item"
            onClick={() => {
              handleLocation();
              handleClose();
            }}
          >
            <Box className="profile-action-icon-wrap">
              <StorefrontOutlinedIcon sx={{ fontSize: "1.25rem", color: "#4b5563" }} />
            </Box>
            <Box className="profile-action-icon-wrap-title">
              <Typography className="profile-action-item-title">Switch location</Typography>
              <Typography className="profile-action-item-subtitle">
                Move to organization and location selection
              </Typography>
            </Box>
          </Box>

          <Box
            className="profile-action-item"
            onClick={() => {
              setActiveTabComp(<Account />);
              setActiveIndex(0);
              navigate("/settings/accounts");
              handleClose();
            }}
          >
            <Box className="profile-action-icon-wrap">
              <PersonOutlineOutlinedIcon sx={{ fontSize: "1.25rem", color: "#4b5563" }} />
            </Box>
            <Box className="profile-action-icon-wrap-title">
              <Typography className="profile-action-item-title">View profile</Typography>
              <Typography className="profile-action-item-subtitle">
                Open operator details and preferences
              </Typography>
            </Box>
          </Box>

          <Box
            className="profile-action-item"
            onClick={() => {
              navigate("/settings/roles-permissions");
              handleClose();
            }}
          >
            <Box className="profile-action-icon-wrap">
              <ShieldCheckIcon
                style={{
                  fontSize: "1.25rem",
                  width: "1.25rem",
                  height: "1.25rem",
                  color: "#4b5563",
                }}
              />
            </Box>
            <Box className="profile-action-icon-wrap-title">
              <Typography className="profile-action-item-title">Roles &amp; Permissions</Typography>
              <Typography className="profile-action-item-subtitle">
                View your assigned roles and access
              </Typography>
            </Box>
          </Box>

          <Box className="profile-action-item" onClick={() => goToLogin("active")}>
            <Box className="profile-action-icon-wrap logout">
              <LogoutIcon sx={{ fontSize: "1.25rem", color: "#e53e3e" }} />
            </Box>
            <Box className="profile-action-icon-wrap-title">
              <Typography className="profile-action-item-title">Logout</Typography>
              <Typography className="profile-action-item-subtitle">
                Sign out and return to login
              </Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Drawer>
  );
});

const BottomNavbar = memo(function BottomNavbar({
  tabList,
  path,
  retailType,
  branchSubType,
  cloudPrint,
  isPrinterOnlineForLocation,
  storeMode,
  lat,
  long,
  city,
  country,
  handleLocation,
  sessionId,
  onLogout,
  hideLogout = false,
  cartGrossBarVisible,
}) {
  const dispatch = useDispatch();
  const managerPin = useSelector(getmangerPin);
  const managerNumber = useSelector(getmangeruidx);
  const [edcOpen, setEdcOpen] = useState(false);
  const [edcLoader, setEdcLoader] = useState(false);
  const [pinValue, setPinValue] = useState("");
  const [pinVisible, setPinVisible] = useState(false);
  const [managerDetails, setManagerDetails] = useState([]);
  const contextId = localStorage.getItem("locId");
  const machineId = localStorage.getItem("machineId");
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showSlowBanner, setShowSlowBanner] = useState(false);
  const [downlinkMbps, setDownlinkMbps] = useState(null);
  const SLOW_THRESHOLD = 1; // Mbps

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  // Speed check — runs on mount and every 30 s while online
  useEffect(() => {
    if (!isOnline) {
      setShowSlowBanner(false);
      return;
    }

    const checkSpeed = async () => {
      const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && conn.downlink != null) {
        const mbps = conn.downlink;
        setDownlinkMbps(mbps);
        setShowSlowBanner(mbps > 0 && mbps < SLOW_THRESHOLD);
        return;
      }
      // Fallback: measure HEAD latency as a proxy
      const t0 = performance.now();
      try {
        await fetch(`/?_nc=${Date.now()}`, { method: "HEAD", cache: "no-store" });
        const ms = performance.now() - t0;
        const estimated = ms < 800 ? 5 : ms < 2000 ? 0.8 : 0.2;
        setDownlinkMbps(estimated);
        setShowSlowBanner(estimated < SLOW_THRESHOLD);
      } catch {
        // fetch error handled by online/offline events
      }
    };

    checkSpeed();
    const id = setInterval(checkSpeed, 30_000);
    return () => clearInterval(id);
  }, [isOnline]);

  // Auto-dismiss slow banner after 8 s
  useEffect(() => {
    if (!showSlowBanner) return;
    const t = setTimeout(() => setShowSlowBanner(false), 8_000);
    return () => clearTimeout(t);
  }, [showSlowBanner]);

  useEffect(() => {
    if (edcOpen) {
      getManagers({ contextId })
        .then((res) => {
          setManagerDetails(
            (res?.data?.data || []).map((e) => ({ value: e?.mobile_number, label: e?.first_name }))
          );
        })
        .catch(() => {});
    }
  }, [edcOpen]);

  const handleEdcClick = () => setEdcOpen(true);

  const handleEdcClose = () => {
    setEdcOpen(false);
    setPinValue("");
    setPinVisible(false);
    dispatch(addmanagerpin(""));
    dispatch(addmanageruidx(""));
  };

  const handleEdcConfirm = (e) => {
    e.preventDefault();
    const targetMode = storeMode === "ONLINE" ? "OFFLINE" : "ONLINE";
    if (targetMode === "ONLINE" && !machineId) return;
    setEdcLoader(true);
    validateManagerPin({ mobile: managerNumber, primaryPassword: managerPin })
      .then(() => {
        localStorage.setItem("storeMode", targetMode);
        localStorage.setItem("cartStoreMode", targetMode);
        setEdcLoader(false);
        handleEdcClose();
      })
      .catch(() => {
        setEdcLoader(false);
        handleEdcClose();
      });
  };

  return (
    <>
      <div className="posnavbar-bottom-bar">
        <div className="posnavbar-bottom-bar-left">
          {tabList?.map((item, index) =>
            item?.hide ? null : (
              <div
                key={index}
                className={`posnavbar-bottom-btn ${
                  item.link?.includes(path) ? "posnavbar-bottom-btn-active" : ""
                }`}
                style={item.disabled ? { cursor: "not-allowed", opacity: 0.5 } : undefined}
                onClick={item.redirect}
              >
                <div className="posnavbar-bottom-btn-icon-wrap">
                  {item.icon}
                  {item.notification && <span className="posnavbar-notif-dot" />}
                </div>
                <span className="posnavbar-bottom-btn-label">{item.label}</span>
              </div>
            )
          )}
        </div>
        <div
          id="cart-gross-bar-portal"
          className={`posnavbar-cart-bar-portal${
            cartGrossBarVisible ? " posnavbar-cart-bar-portal--active" : ""
          }`}
        />
        {!cartGrossBarVisible && (
          <div className="posnavbar-bottom-bar-right">
            {retailType === "RESTAURANT" && branchSubType === "FINE_DINE" && cloudPrint && (
              <div
                className="posnavbar-printer-status"
                title={isPrinterOnlineForLocation ? "Printer Connected" : "Printer Disconnected"}
              >
                <div className="posnavbar-printer-icon-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                    <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
                    <rect x="6" y="14" width="12" height="8" rx="1" />
                  </svg>
                  <span
                    className={`posnavbar-printer-dot ${
                      isPrinterOnlineForLocation
                        ? "posnavbar-printer-dot-online"
                        : "posnavbar-printer-dot-offline"
                    }`}
                  />
                </div>
              </div>
            )}

            <div
              className="posnavbar-payment-btn posnavbar-payment-btn--clickable"
              title={`EDC Machine: ${
                storeMode === "ONLINE"
                  ? "Online — click to disconnect"
                  : "Offline — click to connect"
              }`}
              onClick={handleEdcClick}
              style={{ cursor: "pointer" }}
            >
              <div className="posnavbar-printer-icon-wrap">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <rect width="20" height="14" x="2" y="5" rx="2" />
                  <line x1="2" x2="22" y1="10" y2="10" />
                </svg>
                <span
                  className={`posnavbar-printer-dot ${
                    storeMode === "ONLINE"
                      ? "posnavbar-printer-dot-online"
                      : "posnavbar-printer-dot-offline"
                  }`}
                />
              </div>
            </div>

            <div
              className="posnavbar-wifi-btn"
              title={isOnline ? "Internet: Connected" : "Internet: Disconnected"}
            >
              <div className="posnavbar-printer-icon-wrap">
                {isOnline ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                    <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                    <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                    <line x1="12" x2="12.01" y1="20" y2="20" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <line x1="2" y1="2" x2="22" y2="22" />
                    <path d="M8.5 16.5a5 5 0 0 1 7 0" />
                    <path d="M5 12.55a11 11 0 0 1 5.75-2.93" />
                    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
                    <path d="M19.33 9a15.91 15.91 0 0 0-4.55-2.79" />
                    <path d="M14.47 12.52a11 11 0 0 1 4.61 2.03" />
                    <line x1="12" x2="12.01" y1="20" y2="20" />
                  </svg>
                )}
                <span
                  className={`posnavbar-printer-dot ${
                    isOnline ? "posnavbar-printer-dot-online" : "posnavbar-printer-dot-offline"
                  }`}
                />
              </div>
            </div>

            <WeatherWidget
              latitude={lat}
              longitude={long}
              city={city}
              country={country}
              onChangeLocation={handleLocation}
            />
            {!hideLogout && !sessionId && (
              <div className="posnavbar-logout-btn" onClick={onLogout} title="Logout">
                <LogoutIcon sx={{ fontSize: "1.3rem" }} />
                <span className="posnavbar-logout-label">Logout</span>
              </div>
            )}
          </div>
        )}
      </div>

      {/* ── EDC Mode Toggle Modal ── */}
      {edcOpen && (
        <div className="edc-modal-overlay" onClick={handleEdcClose}>
          <div className="edc-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="edc-modal-close-btn" onClick={handleEdcClose} type="button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>

            <div className="edc-modal-header">
              <div className="edc-modal-lock-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#60a5fa"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="16" r="1" />
                  <rect x="3" y="10" width="18" height="12" rx="2" />
                  <path d="M7 10V7a5 5 0 0 1 10 0v3" />
                </svg>
              </div>
              <h3 className="edc-modal-title">
                {storeMode === "ONLINE" ? "Disconnect EDC Machine" : "Connect EDC Machine"}
              </h3>
              <p className="edc-modal-subtitle">
                {storeMode === "ONLINE"
                  ? "Switching to offline — payments will be independent."
                  : "Switching to online — payments will be sent to the EDC machine."}
              </p>
            </div>

            <div className="edc-modal-body">
              <form onSubmit={handleEdcConfirm}>
                <div className="edc-modal-field">
                  <label className="edc-modal-label">Select Manager</label>
                  <StyledSelect
                    onChange={(e) => dispatch(addmanageruidx(e.value))}
                    options={managerDetails}
                    placeholder="Select a manager"
                    maxMenuHeight={180}
                  />
                </div>
                <div className="edc-modal-field">
                  <label className="edc-modal-label">Enter PIN</label>
                  <div className="edc-modal-pin-wrap">
                    <Input
                      type={pinVisible ? "number" : "password"}
                      inputProps={{ inputMode: "numeric", maxLength: 4 }}
                      autoComplete="new-password"
                      value={pinValue}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "").slice(0, 4);
                        setPinValue(val);
                        dispatch(addmanagerpin(val));
                      }}
                      className="numberInput1"
                      placeholder="••••"
                      disableUnderline
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setPinVisible((v) => !v)}
                            edge="end"
                            size="small"
                          >
                            {pinVisible ? (
                              <VisibilityOff fontSize="small" />
                            ) : (
                              <Visibility fontSize="small" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="edc-modal-confirm-btn"
                  disabled={managerPin?.length < 4 || !managerNumber || edcLoader}
                >
                  {edcLoader ? "Switching…" : storeMode === "ONLINE" ? "Disconnect" : "Connect"}
                </button>
                <button type="button" className="edc-modal-cancel-btn" onClick={handleEdcClose}>
                  Cancel
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ── No Internet Overlay ── */}
      {!isOnline && (
        <div className="net-offline-overlay">
          <div className="net-offline-card">
            <div className="net-offline-icon-ring">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="38"
                height="38"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ffffff"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="2" y1="2" x2="22" y2="22" />
                <path d="M8.5 16.5a5 5 0 0 1 7 0" />
                <path d="M5 12.55a11 11 0 0 1 5.75-2.93" />
                <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
                <path d="M19.33 9a15.91 15.91 0 0 0-4.55-2.79" />
                <path d="M14.47 12.52a11 11 0 0 1 4.61 2.03" />
                <line x1="12" x2="12.01" y1="20" y2="20" />
              </svg>
            </div>
            <h2 className="net-offline-title">No Internet Connection</h2>
            <p className="net-offline-sub">
              You&apos;re offline. Check your Wi-Fi or mobile data and try again.
            </p>
            <div className="net-offline-pills">
              <span className="net-offline-pill">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                  <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                  <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                  <line x1="12" x2="12.01" y1="20" y2="20" />
                </svg>
                Check Wi-Fi
              </span>
              <span className="net-offline-pill">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Check Data
              </span>
            </div>
            <button className="net-offline-retry" onClick={() => window.location.reload()}>
              Try Again
            </button>
            <p className="net-offline-footnote">Will reconnect automatically when back online.</p>
          </div>
        </div>
      )}

      {/* ── Slow Internet Toast ── */}
      {isOnline && showSlowBanner && (
        <div className="net-slow-toast">
          <div className="net-slow-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12.55a11 11 0 0 1 14.08 0" />
              <path d="M1.42 9a16 16 0 0 1 21.16 0" />
              <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
              <line x1="12" x2="12.01" y1="20" y2="20" />
            </svg>
          </div>
          <div className="net-slow-body">
            <div className="net-slow-row">
              <span className="net-slow-title">Slow connection detected</span>
              {downlinkMbps != null && (
                <span className="net-slow-speed">
                  {downlinkMbps < 1
                    ? `${Math.round(downlinkMbps * 1000)} Kbps`
                    : `${downlinkMbps.toFixed(1)} Mbps`}
                </span>
              )}
            </div>
            <p className="net-slow-sub">
              Some features may load slowly. Consider switching to a stronger network.
            </p>
            <div className="net-slow-progress-track">
              <div className="net-slow-progress-bar" />
            </div>
          </div>
          <button
            className="net-slow-close"
            onClick={() => setShowSlowBanner(false)}
            aria-label="Dismiss"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
      )}
    </>
  );
});

const noop = () => {};

// Render the shared bars without mounting the POS session checks, scanner,
// shortcut handlers, or drawer event listeners from Navbar.
export const AccessModeKdsNavbar = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { color = "light" } = useContext(UserContext);
  const branchSubType = localStorage.getItem("branchSubType");
  const user = getFromLocalStorage("retailUserDetails");
  const isFineDine = branchSubType === "FINE_DINE";
  const tabs = [
    { label: "Home", icon: <HomeOutlinedIcon /> },
    { label: isFineDine ? "Tables" : "Cart", icon: isFineDine ? <RestaurantOutlinedIcon /> : <ShoppingCartOutlinedIcon /> },
    { label: "Customers", icon: <PersonOutlineOutlinedIcon /> },
    { label: "Orders", icon: <ReceiptLongOutlinedIcon />, link: ["kitchen-display"] },
    { label: "Hold Orders", icon: <BookmarkBorderIcon /> },
    { label: "Menu On/Off", icon: <ToggleOffOutlinedIcon /> },
    { label: "Logistics", icon: <LocalShippingOutlinedIcon /> },
    { label: "Expenses", icon: <ReceiptLongOutlinedIcon /> },
    { label: "Session", icon: <PersonOutlineOutlinedIcon /> },
    { label: "Support", icon: <HelpOutlineIcon /> },
  ].map((tab) => ({ ...tab, disabled: true, redirect: noop }));

  return (
    <div className={`${color} access-mode-kds-navbar`}>
      <CssBaseline />
      <DisabledNavigation label="Top navigation disabled in KDS access mode">
        <TopNavbar
          navigationDisabled
          pathname={pathname}
          path="kitchen-display"
          color={color}
          retailType="RESTAURANT"
          currentPageLabel="Kitchen Display"
          firstName={user?.firstName || ""}
          dispatchSearch={noop}
          navigate={noop}
          handleRedirect={noop}
          changeColorFun={noop}
          increseScreen={noop}
          setHelpAndSupportDrawerOpen={noop}
          handleOpen={noop}
        />
      </DisabledNavigation>
      <main className="access-mode-kds-content">{children}</main>
      <DisabledNavigation label="Bottom navigation disabled in KDS access mode">
        <BottomNavbar
          tabList={tabs}
          path="kitchen-display"
          retailType="RESTAURANT"
          branchSubType={branchSubType}
          storeMode={localStorage.getItem("storeMode")}
          sessionId={localStorage.getItem("sessionId")}
          hideLogout
          onLogout={noop}
          handleLocation={noop}
        />
      </DisabledNavigation>
      <button
        type="button"
        className="posnavbar-logout-btn access-mode-kds-exit-btn"
        title="Exit KDS"
        onClick={() => navigate("/products/access-mode")}
      >
        <LogoutIcon sx={{ fontSize: "1.3rem" }} />
        <span className="posnavbar-logout-label">Exit</span>
      </button>
    </div>
  );
};

function Navbar({
  pageTitle,
  createMenusearchText,
  setCreateMenuSearchText,
  goToMobileCategory,
  setGoToMobileCategory,
  children,
  showTopNavbar = true, // Added: default to true
  showBottomNavbar = true, // Added: default to true
  globalRefreshLoader = true,
}) {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const [openModalpop, setOpenModalpop] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  const [drawerOpentime, setDrawerOpentime] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const dispatchSearch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [open, setOpen] = useState(!isMobile);
  const [orgLogo, setOrgLogo] = useState("");
  const elem = document.body;
  let {
    color,
    setColor,
    saleMode,
    setTableSelectionModalOpen,
    menuAvailabilityOpen,
    setMenuAvailabilityOpen,
    tableLayoutRefetch,
    tableLayoutStats,
    cartRefetch,
    cartGrossBarVisible,
  } = useContext(UserContext);
  const [controller, dispatch] = useSoftUIController();
  const { isAuth } = controller;
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const firstName = retailUserDetails?.firstName;
  const secondName = retailUserDetails?.secondName;
  const {
    cartItems,
    setCartItems,
    setCartTotalQty,
    cartTotalQty,
    couponApplied,
    setCouponApplied,
    loyaltyPoints,
    setLoyaltyPoints,
    searchText,
    setSearchText,
    isLoadingScreen,
    setIsLoadingScreen,
    hasShownUpdatePopup,
    setHasShownUpdatePopup,
  } = useContext(UserContext);
  const { cartId, setCartId } = useContext(UserContext);
  const { subTotal, setSubTotal } = useContext(UserContext);
  const { total, setTotal } = useContext(UserContext);
  const { cgst, setCgst } = useContext(UserContext);
  const { sgst, setSgst, setCess } = useContext(UserContext);
  const { particularCategoryItems, setparticularCategoryItems } = useContext(UserContext);
  const { categoryName, setCategoryName } = useContext(UserContext);
  const [noresults, setNoresults] = useState(true);
  const appDrawer = useSelector((state) => state.pagination.appDrawer);
  const searchTextValue = useSelector((state) => state.pagination.searchText);
  const searchLoader = useSelector((state) => state.pagination.loading);
  const [showCamera, setShowCamera] = useState(false);
  const isMobilePos = useSelector(getMobilePos);
  const deviceType = useSelector(getDeviceType);
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [quantity, setQuantity] = useState("");
  const profilePic = localStorage.getItem("logoUrl");
  const { highlightMrp, setHighlightMrp } = useContext(UserContext);
  const payment_modes = localStorage.getItem("paymentMethods");
  const orgId = localStorage.getItem("orgId");
  const totalProducts = useSelector(getTotalProducts);
  const scannedProducts = useSelector(getScannedProduct);
  const hasOdsNotif = useSelector(getOdsNotif);
  const [holdOrderDrawerOpen, setHoldOrderDrawerOpen] = useState(false);
  const holdDrawerClosingRef = useRef(false);
  const sessionDrawerClosingRef = useRef(false);
  const [helpAndSupportDrawerOpen, setHelpAndSupportDrawerOpen] = useState(false);
  const [logisticsDrawerOpen, setLogisticsDrawerOpen] = useState(false);
  const [expenseDrawerOpen, setExpenseDrawerOpen] = useState(false);
  const [sessionDrawerOpen, setSessionDrawerOpen] = useState(false);
  const orderMetricDataFullState = useSelector(getFullState);
  const [productCurrentTime, setProductCurrentTime] = useState();
  const [shortcutModal, setShortcutsModal] = useState(false);
  const { setActiveTabComp, setActiveIndex } = useContext(UserContext);
  const retailType = localStorage.getItem("retailType");
  const [openLogoutConfirmationModal, setOpenLogoutConfirmationModal] = useState(false);
  const closeBtnRef = useRef(null);
  const primaryBtnRef = useRef(null);

  const [responseCartTimes, setResponseCartTimes] = useState(() => {
    const item = localStorage.getItem("responseCartTimes");
    return item ? JSON.parse(item) : [];
  });

  const [responseGeneralCartTimes, setResponseGeneralCartTimes] = useState(() => {
    const item = localStorage.getItem("responseGeneralCartTimes");
    return item ? JSON.parse(item) : [];
  });

  const [responseAdvancedCartTimes, setResponseAdvancedCartTimes] = useState(() => {
    const item = localStorage.getItem("responseAdvancedCartTimes");
    return item ? JSON.parse(item) : [];
  });

  const [addItemResponseTime, setAddItemResponseTime] = useState(() => {
    const item = localStorage.getItem("addItemResponseTime");
    return item ? JSON.parse(item) : [];
  });

  const [startTime, setStartTime] = useState("");

  const scanBarcode = useRef();
  const lastSessionCheckRef = useRef(0);
  const { pathname } = useLocation();
  const [appliedState, setAppliedState] = useState(false);
  const sessionId = localStorage.getItem("sessionId");
  const loyaltyCheck = localStorage.getItem("loyaltyCheck");
  const storeMode = localStorage.getItem("storeMode");
  const machineId = localStorage.getItem("machineId");
  const locId = localStorage.getItem("locId");
  const inputRefScan = useRef(null);
  const mode = localStorage.getItem("mode");
  const licenseId = getFromLocalStorage("licenseId");
  const holdOrderCount = useSelector((state) => state.holdOrdersCount.count);

  const allowNegativeSelling =
    !!getFromLocalStorage("appConfig")?.enabledFeatures?.NEGATIVE_INVENTORY;
  const showExpiry = !!getFromLocalStorage("appConfig")?.enabledFeatures?.MULTIPLE_BATCH_EXPIRY;
  const appConfigData = localStorage.getItem("appConfig");
  const appConfig = appConfigData ? JSON.parse(localStorage.getItem("appConfig")) : {};
  const cloudPrint = appConfig?.all?.CLOUD_PRINT?.flag === true;
  const branchSubType = localStorage.getItem("branchSubType");
  const { isPrinterOnlineForLocation } = usePrinterAgentStatus();
  const enabledDisplayModes = appConfig?.settings?.DISPLAY_SYSTEM_MODE?.kdsDisplayScreens;

  const isProfilerOn = localStorage.getItem("profilerSwitch") === "true";

  const handleRedirect = async (path, options = {}) => {
    customEventTrigger(`pos_${getLastPartOfURL(path)}`);
    setIsLoadingScreen(true);
    let daySessionId = getFromLocalStorage("daySessionId");
    try {
      if (!daySessionId) {
        const res = await activeSessionDay(loc_Id);
        if (res?.data?.statusCode === 300) {
          throw new Error(res?.data?.statusCode);
        }
        setInLocalStorage("daySessionId", res?.data?.userSession?.sessionId);
        daySessionId = res?.data?.userSession?.sessionId;
      }

      const res = await getActiveSession(sessionUidx, sessionlocId, daySessionId);
      if (res?.data?.statusCode === 300) {
        throw new Error(res?.data?.statusCode);
      }
      if (res?.data?.hasOwnProperty("machines")) {
        setInLocalStorage("machineId", res?.data?.machines?.[0].machineId || 0);
        if (localStorage.getItem("loggedInCount") == 0 || !localStorage.getItem("loggedInCount")) {
          setInLocalStorage("storeMode", "ONLINE");
          setInLocalStorage("cartStoreMode", "ONLINE");
          setInLocalStorage("loggedInCount", 1);
        }
      }
      setInLocalStorage("licenseId", res?.data?.userSession?.licenseId);
      setInLocalStorage("sessionId", res?.data?.userSession?.sessionId);
      navigate(path, {
        state: {
          resetToSession: options.resetToSession,
          ...options.state,
        },
      });
    } catch (error) {
      if (error?.message === "300") {
        removeFromLocalStorage("sessionId");
        removeFromLocalStorage("licenseId");
        navigate("/session-page/start-day");
        return;
      }
      showSnackbar(error?.message || error?.response?.data?.message, "error");
    } finally {
      setIsLoadingScreen(false);
    }
  };

  function getLastPartOfURL(url) {
    const parts = url.split("/").filter(Boolean);
    return parts.pop();
  }

  useQuery({
    refetchOnWindowFocus: false,
    refetchInterval: 1000 * 60 * 5,
    enabled: !!licenseId,
    queryKey: ["healthCheck"],
    queryFn: async () => {
      const payload = {
        licenseId: licenseId,
        browserVersion: packageJson.version,
        lastHealthCheck: new Date().toISOString(),
      };
      const response = await healthCheck(payload);
      return response?.data;
    },
    onSuccess: (data) => {
      if (
        (data?.updateType === "UPDATE" || data?.updateType === "FORCE_UPDATE") &&
        !hasShownUpdatePopup
      ) {
        setHasShownUpdatePopup(true);
        updateSwal.fire({
          title: "New Update Available",
          text: "Please refresh the page",
          icon: "warning",
          confirmButtonText: "Refresh",
          showCancelButton: true,
          reverseButtons: true,
          preConfirm: async () => {
            window.location.reload();
          },
          backdrop: "rgba(0,0,0,0.6)",
        });
      }
    },
  });

  const handleSettingsShortcut = (Component, activeTabIndex) => {
    setActiveTabComp(Component);
    setActiveIndex(activeTabIndex);
    navigate("/settings");
    e.preventDefault();
  };

  function handleLogoutModal() {
    if (!sessionId) {
      Object.keys(localStorage).forEach((key) => {
        if (key !== "printerConfig") {
          localStorage.removeItem(key);
        }
      });
      return;
    }
    if (sessionDrawerOpen) {
      return;
    }

    setOpenLogoutConfirmationModal(true);
  }

  useEffect(() => {
    if (openLogoutConfirmationModal) {
      // focus primary button by default
      setTimeout(() => {
        primaryBtnRef.current?.focus();
      }, 0);
    }
  }, [openLogoutConfirmationModal]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!openLogoutConfirmationModal) return;

      // ESC → close modal
      if (e.key === "Escape") {
        setOpenLogoutConfirmationModal(false);
        return;
      }

      // ENTER → check which button is focused
      if (e.key === "Enter") {
        e.preventDefault();

        // Check which button is currently focused
        const activeElement = document.activeElement;

        // If Close button is focused or no button is focused (default to Close)
        if (
          activeElement === closeBtnRef.current ||
          !activeElement?.closest(".Confirmation___modal-btn")
        ) {
          // Close the modal
          setOpenLogoutConfirmationModal(false);
          setSessionDrawerOpen(false);
        }
        // If Go to Session button is focused
        else if (activeElement === primaryBtnRef.current) {
          // Go to Session
          setOpenLogoutConfirmationModal(false);
          setSessionDrawerOpen(true);
        }
      }

      // TAB → trap focus inside modal
      if (e.key === "Tab") {
        const focusable = [closeBtnRef.current, primaryBtnRef.current];
        const index = focusable.indexOf(document.activeElement);

        if (e.shiftKey) {
          // shift + tab (backward)
          if (index === 0) {
            e.preventDefault();
            focusable[focusable?.length - 1].focus();
          }
        } else {
          // tab (forward)
          if (index === focusable?.length - 1) {
            e.preventDefault();
            focusable[0].focus();
          }
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [openLogoutConfirmationModal]);

  //  setSessionDrawerOpen(true);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.repeat) return;
      const { key, ctrlKey, altKey } = e;
      const navigateTo = (path) => {
        handleRedirect(path);
        e.preventDefault();
      };

      switch (key?.toLowerCase()) {
        case "h":
          ctrlKey && navigateTo("/dashboard");
          break;
        case "k":
          ctrlKey && navigateTo("/products/customertable");
          break;
        case "o":
          if (ctrlKey) {
            handleRedirect("/orders", { state: { initialTab: "Order History" } });
            e.preventDefault();
          }
          break;
        case "d":
          retailType !== "RESTAURANT" && ctrlKey && navigateTo("/orders");
          break;
        case "s":
          ctrlKey && navigateTo("/settings");
          break;
        case "a":
          ctrlKey && !sessionId && navigateTo("/session-page/start-day");
          break;
        case "z":
          // ctrlKey && navigateTo("/products/holdorderpage");
          ctrlKey && !holdOrderDrawerOpen && setHoldOrderDrawerOpen(true);
          break;
        case "l":
          // altKey && goToLogin("active");

          altKey && handleLogoutModal();
          break;
        case "y":
          ctrlKey && navigateTo("/products/coupons");
          break;
        case "q":
          ctrlKey && setShortcutsModal(true);
          break;
        case "m": {
          const bst = localStorage.getItem("branchSubType");
          const fdSaleMode = localStorage.getItem("fineDineSaleMode");
          const isFineDineNonTable =
            bst === "FINE_DINE" && (fdSaleMode === "DELIVERY" || fdSaleMode === "TAKE_AWAY");
          ctrlKey &&
            navigateTo(
              isFineDineNonTable
                ? "/restaurant/cart"
                : bst === "FINE_DINE"
                ? "/products/table-layout"
                : retailType !== "RESTAURANT"
                ? "/grocery/cart"
                : "/restaurant/cart"
            );
          break;
        }
        case "i":
          if (ctrlKey) {
            handleRedirect("/orders", { state: { initialTab: "Returns" } });
            e.preventDefault();
          }
          break;
        case "g":
          altKey && handleOpen();
          break;
        case "1":
          // altKey && handleSettingsShortcut(<Account />, 0);
          altKey && navigate("/settings/accounts");
          break;
        case "2":
          // altKey && handleSettingsShortcut(<Peripherals />, 3);
          altKey && navigate("/settings/peripherals");
          break;
        case "3":
          break;
        case "4":
          // altKey && handleSettingsShortcut(<NetworkConfig />, 5);
          altKey && navigate("/settings/trouble-shoot");
          break;
        // case "5":
        //   altKey && handleSettingsShortcut(<DisplayModeSettings />, 6);
        //   break;

        case "escape":
          ctrlKey && setShortcutsModal(false);
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [sessionId, shortcutModal, sessionDrawerOpen]);

  // useAppBootstrap();
  const { remaining, timeoutValue } = useIdleChecker();
  useEffect(() => {
    if (remaining == 1) {
      goToLogin("idle");
    }
  }, [remaining, pathname]);

  useEffect(() => {
    if (!payment_modes || payment_modes === undefined) {
      getAllOrgPaymentMethods(orgId)
        .then((res) => {
          let paymentMethods = res?.data?.data?.paymentMethodAvailability?.paymentMethods;
          localStorage.setItem("paymentMethods", paymentMethods);
        })
        .catch((err) => {
          showSnackbar(err.message || err?.response?.data?.message, "error");
        });
    }
  }, [orgId, pathname]);

  const setColorAndPersist = (color) => {
    setColor(color);
    localStorage.setItem("color", color);
    isMobilePos &&
      emit({
        type: "localData",
        data: { color: color },
      });
    document.body.classList.toggle("dark", color === "dark");
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.ctrlKey && e.key === "b") {
        // setColorAndPersist(color === "dark" ? "light" : "dark");
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [color]);

  useEffect(() => {
    open ? dispatchSearch(setAppDrawer(true)) : dispatchSearch(setAppDrawer(false));
  }, [open]);

  const style = useMemo(
    () => ({
      position: "absolute",
      top:
        pathname === "/grocery/cart" || pathname === "/session-page/start-day"
          ? "unset"
          : "4rem",
      right:
        pathname === "/grocery/cart" || pathname === "/session-page/start-day"
          ? "unset"
          : "-16rem",
      bottom:
        pathname === "/grocery/cart" || pathname === "/session-page/start-day"
          ? "5rem"
          : "unset",
      left:
        pathname === "/grocery/cart" || pathname === "/session-page/start-day"
          ? "25rem"
          : "unset",
      transform: "translate(-100%, 0)",
      bgcolor: color === "dark" ? "#353a50" : "background.paper",
      boxShadow: 24,
      p: 1.5,
      width: "17rem",
      height: "fit-content",
      borderRadius: "10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "flex-start",
      textAlign: "center",
      fontSize: "1rem",
      fontWeight: "bold",
      color: color === "dark" ? "white" : "black",
      fontFamily: "sans-serif",
      "&:focus": {
        outline: "none",
      },
    }),
    [pathname, color]
  );

  const cameraStyle = useMemo(
    () => ({
      backgroundColor: color === "dark" ? "#353a50" : "#fff",
      color: color === "dark" ? "white" : "black",
      borderRadius: "10px",
      width: "100%",
      maxWidth: "100vw",
      maxHeight: "100%",
      position: "fixed",
      top: "50%",
      left: "0",
      transform: "translate(0%, -50%)",
      overflowY: "auto",
    }),
    [color]
  );

  const changeColorFun = () => {
    if (color === "dark") {
      setColor("light");
      localStorage.setItem("color", "light");
      isMobilePos && emit({ type: "localData", data: { color: "light" } });
      document.body.classList.remove("dark");
    } else {
      setColor("dark");
      localStorage.setItem("color", "dark");
      isMobilePos && emit({ type: "localData", data: { color: "dark" } });
      document.body.classList.add("dark");
    }
  };

  const increseScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  };

  const triggerDrawer = () => {
    setOpen((prev) => !prev);
  };

  const goToLogin = (status) => {
    if (sessionId && status == "active") {
      // An active session must be closed before signing out — open the session
      // closing drawer directly (same as the Logout action on the Operations menu)
      // instead of only warning the user.
      setOpenModal(false);
      if (!sessionDrawerClosingRef.current) {
        setSessionDrawerOpen(true);
      }
    } else {
      const { os, browser, device } = deviceMetaRef.current;
      const payload = {
        metaData: {
          os: os,
          latitude: lat,
          browser: browser,
          city: city,
          country: country,
          postCode: pCode,
          longitude: long,
          device: device,
        },
      };

      stopNotificationPolling();
      stopTableTaskPolling();
      logoutSession(payload)
        .then((res) => {
          if (status === "idle") {
            showSnackbar(
              `You were logged out due to ${timeoutValue / 60000} minutes of inactivity`,
              "success"
            );
          } else {
            showSnackbar("Successfully Logged out", "success");
          }
          isMobilePos && emit({ type: "localData", data: null });
          Object.keys(localStorage).forEach((key) => {
            if (key !== "printerConfig") {
              localStorage.removeItem(key);
            }
          });
          if (status === "idle") {
            navigate("/", { state: { idleLogout: true, timeoutValue: timeoutValue } });
          } else {
            navigate("/");
          }
        })
        .catch((err) => {
          showSnackbar(err.message, "error");
          isMobilePos && emit({ type: "localData", data: null });
          Object.keys(localStorage).forEach((key) => {
            if (key !== "printerConfig") {
              localStorage.removeItem(key);
            }
          });
        });
    }
  };

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const logoUrl = localStorage.getItem("logoUrl");
    if (!logoUrl && pathname === "/dashboard") {
      getRetailDetails(orgId).then((response) => {
        if (!!response?.data?.es || !response?.data?.retail?.logo) return;
        localStorage.setItem("logoUrl", response?.data?.retail?.logo);
        isMobilePos && emit({ type: "localData", data: { logoUrl: response?.data?.retail?.logo } });
        setOrgLogo(response?.data?.retail?.logo);
      });
      return;
    }
    setOrgLogo(logoUrl);
  }, []);

  const toggleMode = useSelector((state) => state.pagination.toggleMode);
  const isOdsUser = useMemo(() => getFromLocalStorage("user_roles")?.includes("ODS_USER"), []);
  const showOdsTab = getFromLocalStorage("orgConfig")?.odsScreen;

  const tabList = useMemo(
    () => [
      {
        label: "Home",
        link: ["dashboard"],
        redirect: () => {
          handleRedirect("/dashboard");
        },
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        ),
        hide: false,
      },
      {
        label: retailType === "RESTAURANT" && branchSubType === "FINE_DINE" ? "Tables" : "Cart",
        link: [
          "all-products",
          "points",
          "coupons",
          "ProductsPage",
          "paymentpage",
          "twoWay",
          "keyboard",
          "table-layout",
        ],
        redirect: () => {
          const branchSubType = localStorage.getItem("branchSubType");
          const fineDineSaleMode = localStorage.getItem("fineDineSaleMode");
          if (
            branchSubType === "FINE_DINE" &&
            (fineDineSaleMode === "DELIVERY" || fineDineSaleMode === "TAKE_AWAY")
          ) {
            handleRedirect("/restaurant/cart");
          } else if (branchSubType === "FINE_DINE") {
            handleRedirect("/products/table-layout");
          } else if (retailType !== "RESTAURANT") {
            handleRedirect("/grocery/cart");
          } else {
            handleRedirect("/restaurant/cart");
          }
        },
        icon:
          retailType === "RESTAURANT" && branchSubType === "FINE_DINE" ? (
            /* Tables — grid layout with seats */
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <path d="M3 9h18" />
              <path d="M3 15h18" />
              <path d="M9 3v18" />
              <path d="M15 3v18" />
            </svg>
          ) : (
            /* Cart — shopping bag variant */
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <circle cx="8" cy="21" r="1" />
              <circle cx="19" cy="21" r="1" />
              <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
            </svg>
          ),
        hide: false,
      },
      {
        label: "Customers",
        link: ["customertable"],
        redirect: () => {
          handleRedirect("/products/customertable");
        },
        icon: (
          /* Customers — two people */
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        ),
        hide: retailType === "RESTAURANT" ? true : false,
      },
      {
        label: "Orders",
        link: ["delivery"],
        redirect: () => {
          if (retailType === "RESTAURANT") {
            if (!enabledDisplayModes?.find((mode) => mode === "ODS")) {
              handleRedirect("/orders", { state: { initialTab: "Order History" } });
            } else {
              if (isOdsUser) {
                handleRedirect("/orders");
              } else {
                handleRedirect("/orders", { state: { initialTab: "Order History" } });
              }
            }
          } else {
            if (!showOdsTab) {
              handleRedirect("/orders", { state: { initialTab: "Order History" } });
            } else {
              if (isOdsUser) {
                handleRedirect("/orders");
              } else {
                handleRedirect("/orders", { state: { initialTab: "Order History" } });
              }
            }
          }
        },
        icon: (
          /* Orders — file with text lines */
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
            <path d="M14 2v4a2 2 0 0 0 2 2h4" />
            <path d="M10 9H8" />
            <path d="M16 13H8" />
            <path d="M16 17H8" />
          </svg>
        ),
        hide: retailType === "RESTAURANT" ? false : isMobile,
        notification: hasOdsNotif,
      },
      {
        label: "Hold Orders",
        link: ["holdorderpage"],
        redirect: () => {
          window.dispatchEvent(new CustomEvent("pos:open-hold-orders"));
        },
        icon: (
          /* Hold Orders — bookmark */
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
            <line x1="12" y1="8" x2="12" y2="8.01" strokeWidth="2.5" />
            <line x1="10" y1="11" x2="10" y2="14" />
            <line x1="14" y1="11" x2="14" y2="14" />
          </svg>
        ),
        notification: holdOrderCount > 0,
        hide: false,
      },
      {
        label: "Menu On/Off",
        link: [],
        redirect: () => {
          setMenuAvailabilityOpen(true);
        },
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-toggle-left w-5 h-5 transition-colors text-slate-500 group-hover:text-primary"
            aria-hidden="true"
          >
            <circle cx="9" cy="12" r="3"></circle>
            <rect width="20" height="14" x="2" y="5" rx="7"></rect>
          </svg>
        ),
        hide: retailType === "RESTAURANT" ? false : true,
      },
      {
        label: "Logistics",
        link: ["logisticsOrder"],
        redirect: () => {
          // handleRedirect("/logistics");
          window.dispatchEvent(new CustomEvent("pos:open-logistics"));
        },
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-truck w-5 h-5 transition-colors text-slate-500 group-hover:text-primary"
            aria-hidden="true"
          >
            <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path>
            <path d="M15 18H9"></path>
            <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
            <circle cx="17" cy="18" r="2"></circle>
            <circle cx="7" cy="18" r="2"></circle>
          </svg>
        ),
        hide: retailType === "RESTAURANT" ? false : true,
      },
      {
        label: "Expenses",
        link: ["expenseslistpage"],
        disabled: true,
        redirect: () => {
          // handleRedirect("/products/expenses");
          // window.dispatchEvent(new CustomEvent("pos:open-expense"));
          showSnackbar("Feature is coming soon", "info");
        },
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-receipt w-5 h-5 transition-colors text-slate-500 group-hover:text-primary"
            aria-hidden="true"
          >
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
            <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
            <path d="M12 17.5v-11"></path>
          </svg>
        ),
        hide: false,
      },
      // {
      //   label: "Orders Y",
      //   link: ["orderstable"],
      //   redirect: () => {
      //     handleRedirect("/products/orderstable", { resetToSession: true });
      //   },
      //   icon: (
      //     /* Orders (retail) — receipt with zigzag */
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       stroke="currentColor"
      //       strokeWidth="1.6"
      //       strokeLinecap="round"
      //       strokeLinejoin="round"
      //       aria-hidden="true"
      //     >
      //       <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
      //       <path d="M14 8H8" />
      //       <path d="M16 12H8" />
      //       <path d="M13 16H8" />
      //     </svg>
      //   ),
      //   hide: retailType === "RESTAURANT" || retailType === "GROCERY",
      // },
      // {
      //   label: "Returns",
      //   link: ["returntable"],
      //   redirect: () => {
      //     handleRedirect("/returns");
      //   },
      //   icon: (
      //     <svg
      //       xmlns="http://www.w3.org/2000/svg"
      //       width="24"
      //       height="24"
      //       viewBox="0 0 24 24"
      //       fill="none"
      //       stroke="currentColor"
      //       strokeWidth="1.5"
      //       strokeLinecap="round"
      //       strokeLinejoin="round"
      //       aria-hidden="true"
      //     >
      //       <path d="M9 14 4 9l5-5" />
      //       <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
      //     </svg>
      //   ),
      //   hide: retailType === "RESTAURANT" ? true : false,
      // },
      {
        label: "Inventory",
        link: ["stockAdjustment"],
        redirect: () => {
          handleRedirect("/products/inventory");
        },
        icon: <InventoryIcon />,
        hide: true,
      },
      {
        label: "Session",
        link: [
          "start-day",
          "opening",
          "authentication",
          "manager-auth",
          "closing",
          "session-listing",
        ],
        redirect: () => {
          window.dispatchEvent(new CustomEvent("pos:open-close-session"));
          // handleRedirect("/session-page/session-listing");
        },
        icon: (
          /* Session — user with a check mark */
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
            <polyline points="16 11 18 13 22 9" />
          </svg>
        ),
        hide: false,
      },
      {
        label: "Shortcuts",
        link: ["Shortcuts"],
        redirect: () => {
          goToShortcuts();
        },
        icon: <KeyboardOutlinedIcon />,
        hide: true,
      },
      {
        label: "Menu",
        link: ["operations-menu"],
        redirect: () => {
          navigate("/products/operations-menu");
        },
        icon: <Bars3Icon style={{ width: "20px", height: "20px" }} />,
        hide: true,
      },
      {
        label: "Support",
        link: [],
        redirect: () => {
          setHelpAndSupportDrawerOpen(true);
        },
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-headphones h-5 w-5 transition-colors text-slate-500 group-hover:text-primary"
            aria-hidden="true"
          >
            <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path>
          </svg>
        ),
        hide: false,
      },
    ],
    [
      retailType,
      enabledDisplayModes,
      isOdsUser,
      showOdsTab,
      isMobile,
      hasOdsNotif,
      holdOrderCount,
      setMenuAvailabilityOpen,
      setHelpAndSupportDrawerOpen,
    ]
  );

  const sessionUidx = retailUserDetails?.uidx;
  const sessionlocId = localStorage.getItem("locId");
  const daySessionId = localStorage.getItem("daySessionId");
  const [sessionModal, setSessionModal] = useState(false);
  const notifDrawerOpen = false;
  const setNotifDrawerOpen = () => {};
  const readyOrdersCount = 0;
  const readyNotifications = [];
  const currentNotifIndex = 0;
  const notifVisible = true;
  const orderData = [];
  const order_text = useSelector(getOrderText);
  const customer_text = useSelector(getCustomerText);
  const spDetails = useSelector(getSearchOpen);

  const goToShortcuts = () => {
    setShortcutsModal(true);
  };

  useEffect(() => {
    const handler = () => setShortcutsModal(true);
    window.addEventListener("pos:open-shortcuts", handler);
    return () => window.removeEventListener("pos:open-shortcuts", handler);
  }, []);

  useEffect(() => {
    const handler = () => goToLogin("active");
    window.addEventListener("pos:logout", handler);
    return () => window.removeEventListener("pos:logout", handler);
  }, []);

  const closeHoldDrawer = useCallback(() => {
    holdDrawerClosingRef.current = true;
    setHoldOrderDrawerOpen(false);
    setTimeout(() => {
      holdDrawerClosingRef.current = false;
    }, 400);
  }, []);

  const closeSessionDrawer = useCallback(() => {
    if (!localStorage.getItem("sessionId")) return;

    sessionDrawerClosingRef.current = true;
    setSessionDrawerOpen(false);
    setTimeout(() => {
      sessionDrawerClosingRef.current = false;
    }, 400);
  }, []);

  useEffect(() => {
    const handler = () => {
      if (!holdDrawerClosingRef.current) {
        setHoldOrderDrawerOpen(true);
      }
    };
    window.addEventListener("pos:open-hold-orders", handler);
    return () => window.removeEventListener("pos:open-hold-orders", handler);
  }, []);

  useEffect(() => {
    const handler = () => setHelpAndSupportDrawerOpen(true);
    window.addEventListener("pos:open-help-and-support", handler);
    return () => window.removeEventListener("pos:open-help-and-support", handler);
  }, []);

  useEffect(() => {
    const handler = () => setLogisticsDrawerOpen(true);
    window.addEventListener("pos:open-logistics", handler);
    return () => window.removeEventListener("pos:open-logistics", handler);
  }, []);

  useEffect(() => {
    const handler = () => setExpenseDrawerOpen(true);
    window.addEventListener("pos:open-expense", handler);
    return () => window.removeEventListener("pos:open-expense", handler);
  }, []);

  useEffect(() => {
    const handler = () => {
      if (!sessionDrawerClosingRef.current) {
        setSessionDrawerOpen(true);
      }
    };
    window.addEventListener("pos:open-close-session", handler);
    return () => window.removeEventListener("pos:open-close-session", handler);
  }, []);

  const goToSessionPage = () => {
    getActiveSession(sessionUidx, sessionlocId, daySessionId).then((res) => {
      if (res?.data?.statusCode === 300) {
        navigate("/session-page/start-day");
      } else {
        navigate("/session-page/session-listing");
      }
    });
  };

  useEffect(() => {
    if (
      pathname.includes("session-page") ||
      pathname.includes("settings") ||
      pathname.includes("operations-menu")
    ) {
      return;
    }
    // Throttle: only call getActiveSession at most once every 5 minutes
    const now = Date.now();
    if (now - lastSessionCheckRef.current < 5 * 60 * 1000) return;
    lastSessionCheckRef.current = now;

    getActiveSession(sessionUidx, sessionlocId, daySessionId).then((res) => {
      if (res?.data?.statusCode === 300) {
        localStorage.removeItem("sessionId");
        localStorage.removeItem("licenseId");
        localStorage.removeItem("storeMode");
        navigate("/session-page/start-day");
      } else {
        if (res?.data?.hasOwnProperty("machines")) {
          localStorage.setItem("machineId", res?.data?.machines?.[0].machineId || 0);
          if (localStorage.getItem("loggedInCount") === null) {
            localStorage.setItem("storeMode", "ONLINE");
            localStorage.setItem("cartStoreMode", "ONLINE");
            localStorage.setItem("loggedInCount", 1);
          }
        }
        localStorage.setItem("sessionId", res?.data?.userSession?.sessionId);
        localStorage.setItem("licenseId", res?.data?.userSession?.licenseId);
        setInLocalStorage("licenseName", res?.data?.userSession?.licenseName);
        setStartTime(res?.data?.userSession?.startTime);
      }
    });
  }, []);

  const path = useMemo(() => window.location.pathname.split("/").pop(), [pathname]);

  // ─── Derive readable page label for the center chip ──────────────────────
  const currentPageLabel = useMemo(() => {
    // settings sub-pages
    if (pathname.includes("settings")) return "Settings";
    // session sub-pages
    if (pathname.includes("session-page")) {
      return PAGE_LABEL_MAP[path] || "Session";
    }
    return PAGE_LABEL_MAP[path] || null;
  }, [path, pathname]);

  // Is this the table-layout page (show Order Ready chip)?
  const isTableLayout = pathname === "/products/table-layout";

  useEffect(() => {
    const bodyElement = document.getElementsByTagName("body")[0];
    if (color === "dark") {
      bodyElement.classList.add("dark");
    } else {
      bodyElement.classList.remove("dark");
    }
    // if (localStorage.getItem("color") === "dark") {
    //   setColor("dark");
    // } else {
    //   setColor("light");
    // }
  }, [color]);

  useEffect(() => {
    if (customer_text || order_text || searchText) {
      dispatchSearch(orderFilter(""));
      dispatchSearch(customerFilter(null));
      setSearchText("");
    }
  }, []);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "`" && pathname !== "/grocery/cart") {
        inputRefScan.current?.focus();
        e.preventDefault();
      }
    };
    document.addEventListener("keyup", handleKeyPress);
    if (
      pathname === "/products/customertable" ||
      pathname === "/products/orderstable" ||
      pathname === "/products/holdorderpage"
    ) {
      inputRefScan.current?.focus();
    }
    return () => {
      document.removeEventListener("keyup", handleKeyPress);
    };
  }, [pathname]);

  const clickPress = (event) => {
    dispatchSearch(searchTextRes(event.target.value));
    dispatchSearch(searchTextRespaymnet(event.target.value));
    dispatchSearch(setLoading(true));
    if (
      pathname == "/products/all-products" ||
      pathname == "/restaurant/cart" ||
      pathname === "/grocery/cart"
    ) {
      dispatchSearch(setLoading(true));
      const suggestionPayload = {
        query: event.target.value,
        flattenResponse: true,
        storeLocations: [locId],
        storeIds: [orgId]
      };
      customEventTrigger("pos_particular_product_page", { search_term: event.target.value });
      FilterProduct(suggestionPayload)
        .then((res) => {
          if (res?.data?.data?.data?.totalRecords === "0") {
            setNoresults(true);
            setparticularCategoryItems([]);
            showSnackbar("No results found!", "error");
          } else {
            setparticularCategoryItems(res?.data?.data?.data?.data);
            setNoresults(false);
          }
          dispatchSearch(setLoading(false));
        })
        .catch((err) => {
          particularCategoryDataFun(categoryName);
          dispatchSearch(setLoading(false));
        });
    } else if (pathname == "/products/orderstable") {
      customEventTrigger("pos_orderstable_search", { search_term: event.target.value });
      dispatchSearch(orderFilter(event.target.value));
      dispatchSearch(setLoading(false));
    } else if (pathname == "/products/customertable") {
      const value = event?.target?.value?.trim();
      const mobile = !isNaN(Number(value)) && value !== "" ? value : null;
      const name = isNaN(Number(value)) ? value : null;
      /*
      let cusPayload = {
        orgId: orgId,
        pageNo: 0,
        pageSize: 10,
        mobile: mobile,
        name: name,
      };
      */
      let cusPayload = {
        organizationId: orgId,
        search: value,
        pageNumber: 0,
        pageSize: 10,
      };
      customEventTrigger("pos_customer_table_search", { searchText: event.target.value });
      let uidxArr = [];
      /*
      customerSearch(cusPayload)
      */
      customerSearchV2Api(cusPayload)
        .then((res) => {
          if (res?.data?.es > 0) {
            showSnackbar(res?.data?.message, "error");
            const payload = { uidx: uidxArr };
            dispatchSearch(customerFilter({ p: payload, r: res }));
            dispatchSearch(setLoading(false));
          }
          if (res?.data?.customers) {
            let dataArr = res?.data?.customers;
            dataArr?.map((e) => {
              uidxArr.push(e?.uidx || e?.id);
            });
            const payload = { uidx: uidxArr };
            dispatchSearch(customerFilter({ p: payload, r: res }));
          } else {
            dispatchSearch(customerFilter(null));
          }
        })
        .catch((err) => {
          showSnackbar(err?.message, "error");
          setLoading(false);
        });
    } else {
      dispatchSearch(setLoading(false));
    }
  };

  const debouncedClickPress = debounce(clickPress, 500);

  const debouncedCustomerSearch = (event) => {
    if (inputRefScan.current) {
      clearTimeout(inputRefScan.current);
    }
    inputRefScan.current = setTimeout(() => {
      clickPress(event);
    }, 500);
  };

  const particularCategoryDataFun = (categoryName) => {
    let payload = {
      page: 1,
      pageSize: 10,
      appCategories: { categoryLevel1: [categoryName] },
      flattenResponse: true,
      storeLocations: [locId],
      storeIds: [orgId]
    };
    setparticularCategoryItems([]);
    FilterProduct(payload)
      .then((res) => {
        const cmsResult = res?.data?.data?.data?.data;
        setparticularCategoryItems(cmsResult);
        setCategoryName(categoryName);
        setNoresults(false);
      })
      .catch((err) => {});
  };

  const [selectedMrp, setSelectedMrp] = useState("");
  const [SelectedSellingPrice, setSelectedSellingPrice] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [selectedGtin, setSelectedGtin] = useState("");
  const [sellingUnit, setSellingUnit] = useState("");
  const [availableUnits, setAvailableUnits] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [brandName, setBrandName] = useState("");
  const [packagingType, setPackagingType] = useState("");
  const [variantName, setVariantName] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [mrps, setMrps] = useState([]);
  const [spModal, setSpModal] = useState(false);
  const { animationBox, setanimationBox, setOfferFound, offerFound } = useContext(UserContext);
  const { gtinItem, setItemgtin } = useContext(UserContext);
  const barcodeRef = useRef(null);
  const audioTimeoutRef = useRef(null);
  const { addItemWithCheck, addItemDirect } = useAddToCart();
  const [isScanningItem, setIsScanningItem] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [barcodeErr, setBarcodeErr] = useState(true);
  const [startT, setStartT] = useState("");
  const [endT, setEndT] = useState("");
  const [counter, setCounter] = useState(0);
  const [offerData, setOfferData] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const doFetchInventory = (payload) => {
    if (isScanningItem) return;
    setIsScanningItem(true);
    addItemWithCheck(payload, {
      onBatchSelect: (dataArr) => {
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - startTime;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        if (
          pathname == "/products/all-products" ||
          pathname == "/restaurant/cart" ||
          pathname == "/grocery/cart"
        ) {
          if (dataArr.length === 1) {
            addItemWithScanner(
              { gtin: dataArr[0].gtin },
              dataArr[0].mrp,
              dataArr[0].sellingPrice,
              dataArr[0].batchNum,
              dataArr[0].purchasePrice,
              dataArr[0].sellingUnit,
              dataArr[0].offers,
              dataArr[0].availableUnits,
              dataArr[0].expiryDate
            );
          } else {
            setBrandName(dataArr[0]?.brand);
            setPackagingType(dataArr[0]?.packagingType);
            setVariantName(dataArr[0]?.variantName);
            setVendorId(dataArr[0]?.vendorId);
            setExpiryDate(dataArr[0]?.expiryDate || "");
            setMrps(dataArr);
            setOfferData(dataArr[0]?.offers);
            setSelectedMrp(dataArr[0]?.mrp);
            setSelectedSellingPrice(dataArr[0]?.sellingPrice);
            setBatchNo(dataArr[0]?.batchNum);
            setPurchasePrice(dataArr[0]?.purchasePrice);
            setExpiryDate(dataArr[0]?.expiryDate);
            setSelectedProduct(name);
            setSellingUnit(dataArr[0]?.sellingUnit);
            setOpenModalpop(true);
            setanimationBox(true);
            setDisabled(true);
            setItemgtin(selectedGtin);
            setHighlightMrp(dataArr[0]?.sellingPrice);
            setBarcodeLoading(false);
            dispatchSearch(focusBarcode(false));
          }
        }
      },
      onSuccess: (cartData) => {
        if (isProfilerOn) {
          const end = new Date().getTime();
          const timeTaken = end - startTime;
          const updatedResponseTimes = [
            ...addItemResponseTime,
            { time: end, responseTime: timeTaken },
          ];
          localStorage.setItem("addItemResponseTime", JSON.stringify(updatedResponseTimes));
          setAddItemResponseTime(updatedResponseTimes);
        }
        if (
          pathname == "/products/all-products" ||
          pathname == "/restaurant/cart" ||
          pathname == "/grocery/cart"
        ) {
          const end = new Date().getTime();
          if (pathname == "/products/all-products") {
            const itemSuccessResponse = [
              ...responseGeneralCartTimes,
              { time: end, responseTime: end - startT },
            ];
            localStorage.setItem("responseGeneralCartTimes", JSON.stringify(itemSuccessResponse));
            setResponseGeneralCartTimes(itemSuccessResponse);
          }
          if (pathname == "/grocery/cart") {
            const itemAdSuccessResponse = [
              ...responseAdvancedCartTimes,
              { time: end, responseTime: end - startT },
            ];
            localStorage.setItem(
              "responseAdvancedCartTimes",
              JSON.stringify(itemAdSuccessResponse)
            );
            setResponseAdvancedCartTimes(itemAdSuccessResponse);
          }
          // applyCartState (called by the hook) already set cartItems, cgst, sgst, cess, total, subTotal, offerFound, cartTotalQty
          setCouponApplied(cartData?.billing?.appliedCoupon);
          localStorage.removeItem("loyaltyPoints");
          setAppliedState(!appliedState);
          setSellingUnit("");
          setSelectedMrp("");
          setSelectedSellingPrice("");
          setBatchNo("");
          setPurchasePrice("");
          setSelectedGtin("");
          setSelectedProduct("");
          setOfferData("");
          setMrps([]);
          setItemgtin(selectedGtin);
          setHighlightMrp(cartData?.cartProducts?.[0]?.sellingPrice);
          const currentTime = new Date().getTime();
          dispatchSearch(incrementScannedProduct(scannedProducts + 1));
          dispatchSearch(changePrevAddedTime(currentTime));
          dispatchSearch(setTotalProducts(totalProducts + 1));
          dispatchSearch(addingProductTime(currentTime - productCurrentTime));
          const backupData = {
            ...orderMetricDataFullState,
            scannedProduct: scannedProducts + 1,
            totalProducts: totalProducts + 1,
            prevAddedProductTime: currentTime,
            productTimeArray: [
              ...orderMetricDataFullState.productTimeArray,
              currentTime - productCurrentTime,
            ],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
          showSnackbar("Item added successfully", "success");
          setBarcodeLoading(false);
          dispatchSearch(focusBarcode(false));
          (isMobilePos || deviceType === "android") &&
            emit({ type: "productAdded", data: { success: true } });
        }
      },
      onBeforeError: () => {
        setBarcodeLoading(false);
        dispatchSearch(focusBarcode(false));
        (isMobilePos || deviceType === "android") &&
          emit({ type: "productAdded", data: { success: false } });
      },
      onError: async (errMsg, source) => {
        /* Grocery cart: an inventory error from the API means the product was never
           inwarded — show the same dialog as the search drawer instead of a snackbar. */
        if (pathname !== "/grocery/cart" || source !== "api" || !/inventory/i.test(errMsg)) {
          showSnackbar(errMsg, "error");
          return;
        }
        await newSwal.fire(withSwalKeyboardNav({
          title: "",
          html:
            `<div style="text-align:center;padding:4px 0 16px;">` +
              `<div style="width:60px;height:60px;border-radius:50%;background:#fef2f2;display:flex;align-items:center;justify-content:center;margin:0 auto 12px;border:2px solid #fecaca;">` +
                `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">` +
                  `<path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>` +
                  `<line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>` +
                `</svg>` +
              `</div>` +
              `<p style="font-size:17px;font-weight:700;color:#0f172a;margin:0 0 4px;">No Inventory Found</p>` +
              `<p style="font-size:12.5px;color:#64748b;margin:0 0 16px;line-height:1.5;">${payload?.gtin || ""}</p>` +
            `</div>` +
            `<div style="background:#fef2f2;border:1.5px solid #fecaca;border-radius:12px;padding:14px 16px;text-align:left;">` +
              `<p style="margin:0 0 6px;font-size:13px;font-weight:700;color:#991b1b;">Cannot add to cart</p>` +
              `<p style="margin:0;font-size:12.5px;color:#7f1d1d;line-height:1.65;">` +
                `This product has <strong>no inward records</strong>. Please complete a GRN (goods receipt note) in Pallet ROS before this product can be sold at the POS.` +
              `</p>` +
            `</div>`,
          showCancelButton: false,
          confirmButtonText: "Got it",
          width: "460px",
          willOpen: (popup) => {
            /* Keep the popup above any open MUI modal (z-index 1300) */
            const container = popup.closest(".swal2-container");
            if (container) container.style.zIndex = "99999";
          },
          didOpen: (popup) => {
            const confirmBtn = popup.querySelector(".swal2-confirm");
            if (confirmBtn) confirmBtn.style.cssText =
              "background:#2a71ff;color:#fff;border:none;padding:10px 28px;" +
              "border-radius:8px;font-weight:700;font-size:13.5px;cursor:pointer;min-width:120px;margin-top:16px;";
          },
        }));
        dispatchSearch(focusBarcode(false));
      },
    }).finally(() => setIsScanningItem(false));
  };

  const { findWeighingItem, renderWeighingModal, weighingStatus } = useWeighingItemModal();

  /* Grocery cart: a plain product barcode of a weighing-scale item must open the
     quantity modal (same as the search flow) instead of adding qty 1 directly.
     Scale-printed "W..." barcodes already carry the weight, so they add directly. */
  const scanIntoGroceryCart = (payload) => {
    const scanned = payload?.gtin || "";
    if (scanned.toLowerCase().startsWith("w")) {
      doFetchInventory(payload);
      return;
    }
    setIsScanningItem(true);
    FilterProduct({
      page: 1,
      pageSize: 1,
      query: "",
      barcode: [scanned],
      storeIds: [orgId],
      storeLocations: [locId],
      flattenResponse: true,
    })
      .then((res) => {
        const products = res?.data?.data?.data?.data;
        const product = Array.isArray(products)
          ? products.find(
              (p) => p?.gtin === scanned || p?.variant?.barcodes?.includes(scanned)
            ) || products[0]
          : null;
        return product?.variant?.needsWeighingScaleIntegration === true ? product : null;
      })
      .catch(() => null)
      .then((weighingProduct) => {
        setIsScanningItem(false);
        if (
          weighingProduct &&
          findWeighingItem(
            scanned,
            weighingProduct?.variant?.name || weighingProduct?.name || "",
            "weighingScale",
            weighingProduct?.variant?.weightUnit || weighingProduct?.variant?.sellingUnit
          )
        ) {
          setBarcodeLoading(false);
          dispatchSearch(focusBarcode(false));
          return;
        }
        doFetchInventory(payload);
      });
  };

  useDisableNumberInputScroll();

  useNativeMessage((message) => {
    const data = JSON.parse(message?.data);
    if (message?.type === "gtin") {
      if (!isScanningItem) {
        const { newGtin, quantity } = checkGtinType(data?.gtin);
        setQuantity(quantity || "");
        const scanPayload = {
          gtin: data?.gtin,
          cartId: cartId,
          locationId: locId,
          orgId: orgId,
          allowNegativeSelling: allowNegativeSelling,
        };
        if (pathname === "/grocery/cart") {
          scanIntoGroceryCart(scanPayload);
        } else {
          doFetchInventory(scanPayload);
        }
        setSelectedGtin(data?.gtin);
        setItemgtin(data?.gtin);
      }
    }
  });

  const handleModalClose = () => {
    setOpenModalpop(false);
  };

  const addItemWithScanner = async (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingUnit,
    offer,
    availableUnits,
    expiryDate,
    brand,
    packagingType,
    itemName,
    vendorId
  ) => {
    if (showExpiry && expiryDate && new Date(expiryDate) < new Date()) {
      const expiryResult = await newSwal.fire(withSwalKeyboardNav({
        title: "Expired Product",
        text: "This product has expired. Do you want to proceed with selling?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Proceed anyway",
        cancelButtonText: "Cancel",
        allowEnterKey: false,
        reverseButtons: true,
        willOpen: (popup) => {
          /* Keep the popup above the MUI batch modal (z-index 1300) */
          const container = popup.closest(".swal2-container");
          if (container) container.style.zIndex = "99999";
        },
      }));
      if (!expiryResult.isConfirmed) {
        console.log("User cancelled expired product selling operation");
        setBarcodeLoading(false);
        dispatchSearch(focusBarcode(false));
        return;
      }
    }
    if (!allowNegativeSelling && !availableUnits) {
      /* gtin may arrive as { gtin: "..." } object or plain string */
      const gtinStr = typeof gtin === "object" ? gtin?.gtin || "" : gtin || "";
      const productName = itemName || "Product";

      const inventoryResult = await newSwal.fire(withSwalKeyboardNav({
        title: "",
        html:
          /* ── Product card ── */
          `<div style="background:#f8fafc;border-radius:12px;padding:14px 16px;display:flex;align-items:center;gap:14px;margin-bottom:14px;border:1.5px solid #e2e8f0;text-align:left;">` +
          `<div style="width:56px;height:56px;border-radius:8px;background:linear-gradient(135deg,#2a71ff,#6366f1);display:flex;align-items:center;justify-content:center;flex-shrink:0;">` +
          `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.9)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">` +
          `<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>` +
          `<polyline points="3.29 7 12 12 20.71 7"/><line x1="12" y1="22" x2="12" y2="12"/>` +
          `</svg>` +
          `</div>` +
          `<div style="flex:1;min-width:0;">` +
          `<p style="margin:0 0 4px;font-size:13.5px;font-weight:700;color:#0f172a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${productName}</p>` +
          (gtinStr
            ? `<p style="margin:0 0 6px;font-size:11px;font-family:'Courier New',monospace;color:#64748b;letter-spacing:0.06em;">${gtinStr}</p>`
            : "") +
          `<span style="display:inline-flex;align-items:center;gap:5px;font-size:12.5px;font-weight:700;color:#b45309;background:#fef3c7;border-radius:999px;padding:3px 11px;">` +
          `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>` +
          `No inventory` +
          `</span>` +
          `</div>` +
          `</div>` +
          /* ── Warning body ── */
          `<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:10px;padding:12px 14px;text-align:left;">` +
          `<p style="margin:0;font-size:13px;color:#78350f;line-height:1.65;">` +
          `You can continue selling at the <strong>last inwarded batch selling price</strong> — the system will tag this as <strong>oversold inventory</strong>.` +
          `<br><br>Do you want to add to cart?` +
          `</p>` +
          `</div>`,
        showCancelButton: true,
        confirmButtonText: "Yes, add to cart",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        width: "500px",
        willOpen: (popup) => {
          /* Keep the popup above the MUI batch modal (z-index 1300) */
          const container = popup.closest(".swal2-container");
          if (container) container.style.zIndex = "99999";
        },
        didOpen: (popup) => {
          const confirm = popup.querySelector(".swal2-confirm");
          const cancel = popup.querySelector(".swal2-cancel");
          if (confirm) {
            confirm.style.cssText =
              "background:#2a71ff;color:#fff;border:none;padding:10px 26px;" +
              "border-radius:8px;font-weight:700;font-size:13.5px;cursor:pointer;min-width:130px;";
          }
          if (cancel) {
            cancel.style.cssText =
              "background:transparent;color:#2a71ff;border:2px solid #2a71ff;" +
              "padding:9px 26px;border-radius:8px;font-weight:700;font-size:13.5px;" +
              "cursor:pointer;min-width:100px;";
          }
        },
      }));
      if (!inventoryResult.isConfirmed) {
        setBarcodeLoading(false);
        dispatchSearch(focusBarcode(false));
        return;
      }
    }
    await proceedWithAddItem(
      gtin,
      mrp,
      sp,
      batchNo,
      purchasePrice,
      sellingUnit,
      offer,
      availableUnits,
      expiryDate,
      brand,
      packagingType,
      itemName,
      vendorId
    );
  };

  const proceedWithAddItem = async (
    gtin,
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingUnit,
    offer,
    availableUnits,
    expiryDate,
    brand,
    packagingType,
    itemName,
    vendorId
  ) => {
    setProductCurrentTime(new Date().getTime());
    const currentTime = new Date().getTime();
    setHighlightMrp(sp);
    if (quantity) {
      var newQuantity = checkUnitType(parseInt(quantity, 10), sellingUnit?.toLowerCase());
    }
    setSelectedGtin(gtin?.gtin);
    const addCustomerPayload = {
      cartId: cartId,
      gtin: gtin.gtin,
      sellingPrice: sp,
      locationId: locId,
      mrp: mrp,
      inventoryChecks: "NO",
      batchNo: batchNo || "",
      isOfferAvailable:
        offer?.offersList.length > 0 || offerData?.offersList.length > 0 ? true : false,
      purchasePrice: purchasePrice || "",
      sellingUnit: sellingUnit,
      expiryDate: expiryDate?.split("+")[0],
      variantName: itemName,
      vendorId: vendorId,
      packagingType: packagingType,
      brandName: brand,
    };
    const start = new Date().getTime();
    try {
      await addItemDirect(addCustomerPayload, cartItems, {
        onBeforeError: () => {
          setBarcodeLoading(false);
          dispatchSearch(focusBarcode(false));
          (isMobilePos || deviceType === "android") &&
            emit({ type: "productAdded", data: { success: false } });
        },
        onSuccess: (cartData) => {
          if (isProfilerOn) {
            const end = new Date().getTime();
            const timeTaken = end - start;
            const updatedResponseTimes = [
              ...responseCartTimes,
              { time: end, responseTime: timeTaken },
            ];
            localStorage.setItem("responseCartTimes", JSON.stringify(updatedResponseTimes));
            setResponseCartTimes(updatedResponseTimes);
            if (pathname == "/products/all-products") {
              const itemSuccessResponse = [
                ...responseGeneralCartTimes,
                { time: end, responseTime: end - startT },
              ];
              localStorage.setItem("responseGeneralCartTimes", JSON.stringify(itemSuccessResponse));
              setResponseGeneralCartTimes(itemSuccessResponse);
            }
            if (pathname == "/grocery/cart") {
              const itemAdSuccessResponse = [
                ...responseAdvancedCartTimes,
                { time: end, responseTime: end - startT },
              ];
              localStorage.setItem(
                "responseAdvancedCartTimes",
                JSON.stringify(itemAdSuccessResponse)
              );
              setResponseAdvancedCartTimes(itemAdSuccessResponse);
            }
          }
          const newTime = new Date().getTime();
          dispatchSearch(incrementScannedProduct(scannedProducts + 1));
          dispatchSearch(changePrevAddedTime(currentTime));
          dispatchSearch(setTotalProducts(totalProducts + 1));
          dispatchSearch(addingProductTime(newTime - currentTime));
          const backupData = {
            ...orderMetricDataFullState,
            scannedProduct: scannedProducts + 1,
            totalProducts: totalProducts + 1,
            prevAddedProductTime: currentTime,
            productTimeArray: [...orderMetricDataFullState.productTimeArray, newTime - currentTime],
          };
          localStorage.setItem("orderMetricData", JSON.stringify(backupData));
          showSnackbar("Item added successfully", "success");
          // applyCartState (called by hook) already set cartItems, cgst, sgst, cess, total, subTotal, offerFound, cartTotalQty
          setCouponApplied(cartData?.billing?.appliedCoupon);
          localStorage.removeItem("loyaltyPoints");
          setAppliedState(!appliedState);
          setItemgtin(gtin?.gtin);
          setBarcodeLoading(false);
          dispatchSearch(focusBarcode(false));
          (isMobilePos || deviceType === "android") &&
            emit({ type: "productAdded", data: { success: true } });
        },
      });
    } finally {
      dispatchSearch(scanEnd(true));
    }
  };

  useEffect(() => {
    if (checkPath(["coupons", "points", "twoWay", "keyboard", "all-products"])) {
      const activeCartId = localStorage.getItem("CartId");

      if (!!loyaltyPoints && activeCartId) {
        removeLoyalty(activeCartId).then((res) => {
          localStorage.removeItem("loyaltyPoints");
          setTotal(res?.data?.data?.billing?.totalCartValue);
          setLoyaltyPoints(res?.data?.data?.loyaltyPointsValue);
        });
      }
    }
  }, [appliedState, cartItems, cartTotalQty]);

  const handlePrice = (
    mrp,
    sp,
    batchNo,
    purchasePrice,
    sellingUnit,
    offers,
    availableUnits,
    expiryDate
  ) => {
    setDisabled(false);
    setSelectedMrp(mrp);
    setOfferData(offers);
    setSelectedSellingPrice(sp);
    setBatchNo(batchNo);
    setPurchasePrice(purchasePrice);
    setSellingUnit(sellingUnit);
    setAvailableUnits(availableUnits);
    setExpiryDate(expiryDate);
  };

  const handleNaviagteproduct = () => {
    navigate(-1);
  };

  const rt = localStorage.getItem("refresh_token");
  const [isLoggedIn, setIsLoggedIn] = useState("");
  const delay = 1800000;

  const handleLocation = () => {
    if (sessionId) {
      showSnackbar("Close session to change location", "error");
    } else {
      navigate("/products/location");
    }
  };

  useEffect(() => {
    if (rt?.length > 10) {
      rtValidation()
        .then((response) => {
          setIsLoggedIn(false);
        })
        .catch((error) => {
          if (error?.response?.data?.message == "UNAUTHORIZED RT") {
            localStorage.clear();
            navigate("/");
          }
        });
    } else if (rt == null && pathname == "/") {
      setIsLoggedIn(false);
    }
  }, [pathname]);

  useEffect(() => {
    if (rt?.length > 10) {
      const interval = setInterval(() => {
        atRefresh()
          .then((response) => {
            localStorage.setItem("access_token", response.data.data.at);
            localStorage.setItem("refresh_token", response.data.data.rt);
            setIsLoggedIn(false);
          })
          .catch((err) => {
            if (err?.response?.data.code == 401) {
              Object.keys(localStorage).forEach((key) => {
                if (key !== "printerConfig") localStorage.removeItem(key);
              });
              setIsLoggedIn(true);
              navigate("/");
            }
          });
      }, delay);
      return () => clearInterval(interval);
    } else {
      localStorage.clear();
      setIsLoggedIn(true);
    }
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const play = () => {
    var audio = new Audio(
      "https://media.geeksforgeeks.org/wp-content/uploads/20190531135120/beep.mp3"
    );
    audio.play();
  };

  const handleBarcodeErr = (e) => {
    if (barcodeErr) {
      setSpModal(false);
    } else {
      window.location.reload();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && barcodeErr) {
        handleBarcodeErr();
      }
    });
    return document.removeEventListener("keydown", handleBarcodeErr);
  }, []);

  const handleSetting = () => {
    navigate("/settings");
  };

  const loc_Id = localStorage.getItem("locId");

  const setPlaceholderText = useCallback((path) => {
    switch (path) {
      case "customertable":
        return "Search Customer";
      case "orderstable":
        return "Search By Order Id, Invoice Id, Customer Number";
      case "holdorderpage":
        return "Search Hold Orders";
      case "returns":
        return "Search Returns";
      case "table-layout":
        return "Search KOT, table no.";
      default:
        return "Search Products";
    }
  }, []);

  const checkPath = (pathArray) => pathArray.some((arrayItem) => arrayItem === path);

  const clearSearch = () => {
    dispatchSearch(searchTextRes(""));
    dispatchSearch(searchTextRespaymnet(""));
    dispatchSearch(orderFilter("")); // ✅ Add this line
    dispatchSearch(returnFilter(""));
    dispatchSearch(customerFilter(null)); // ✅ Add this line
    setparticularCategoryItems([]);
    setSearchText("");
    if (pathname === "/products/customertable") {
      clickPress({ target: { value: "" } });
    }
  };

  const renderEndIcon = () => {
    if (!!searchText) {
      if (searchLoader) {
        return (
          <div className="search-loader">
            <CircularProgress size={22} />
          </div>
        );
      }
      return <ClearIcon className="clear-icon" onClick={clearSearch} />;
    }
    return null;
  };

  const getPageTitle = (path) => {
    switch (path) {
      case "paymentpage":
        return "Cart";
      case "coupons":
        return "Coupons";
      case "points":
        return "Points";
      default:
        return "";
    }
  };

  const goToMenu = () => {
    setOpenMenu(true);
  };

  const deviceMetaRef = useRef({
    os: "",
    browser: "",
    device: "",
  });
  const [locationInfo, setLocationInfo] = useState({
    lat: "",
    long: "",
    city: "",
    state: "",
    country: "",
    pCode: "",
  });
  const { lat, long, city, country, pCode } = locationInfo;
  const isOdsRoute = pathname === "/orders";

  useEffect(() => {
    const operatingSystem = navigator.platform;
    const userAgent = window.navigator.userAgent;
    let browser = "Other";
    if (userAgent.includes("Chrome")) browser = "Google Chrome";
    else if (userAgent.includes("Firefox")) browser = "Mozilla Firefox";
    else if (userAgent.includes("Safari") && !userAgent.includes("Chrome"))
      browser = "Apple Safari";
    else if (userAgent.includes("Edge")) browser = "Microsoft Edge";
    else if (userAgent.includes("Opera") || userAgent.includes("OPR")) browser = "Opera";
    else if (userAgent.includes("MSIE") || userAgent.includes("Trident/"))
      browser = "Internet Explorer";
    let device = "This device is tablet";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
        navigator.userAgent
      )
    ) {
      device = "This device is Mobile";
    } else if (/Windows/i.test(navigator.userAgent)) {
      device = "This device is Desktop";
    }
    deviceMetaRef.current = {
      os: operatingSystem,
      browser,
      device,
    };
  }, []);

  useEffect(() => {
    // Run once on mount only — location data does not change between route navigations
    navigator.geolocation.getCurrentPosition(function (position) {
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;
      setLocationInfo((prev) => ({
        ...prev,
        lat: latitude,
        long: longitude,
      }));
      getLocDetailByLongAndLat(latitude, longitude)
        .then((res) => {
          if (res?.data?.address) {
            const nextCity =
              res?.data?.address?.city || res?.data?.address?.village || res?.data?.address?.town;
            setLocationInfo((prev) => ({
              ...prev,
              city: nextCity,
              state: res?.data?.address?.state || "",
              country: res?.data?.address?.country || "",
              pCode: res?.data?.address?.postcode || "",
            }));
          }
        })
        .catch((err) => {});
    });
  }, []);

  useEffect(() => {
    if (sessionId && (storeMode === null || storeMode === undefined || storeMode === "")) {
      if (machineId) {
        if (
          localStorage.getItem("loggedInCount") === null ||
          localStorage.getItem("loggedInCount") === undefined ||
          localStorage.getItem("loggedInCount") === "0"
        ) {
          localStorage.setItem("cartStoreMode", "ONLINE");
          localStorage.setItem("storeMode", "ONLINE");
          localStorage.setItem("loggedInCount", "1");
        }
      } else {
        if (
          localStorage.getItem("loggedInCount") === null ||
          localStorage.getItem("loggedInCount") === undefined ||
          localStorage.getItem("loggedInCount") === "0"
        ) {
          localStorage.setItem("cartStoreMode", "OFFLINE");
          localStorage.setItem("storeMode", "OFFLINE");
          localStorage.setItem("loggedInCount", "1");
        }
      }
    }
  }, [machineId, sessionId]);

  const styleI = useMemo(
    () => ({
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
    }),
    []
  );

  const handleCloseShorctcutModal = () => {
    setShortcutsModal(false);
  };

  useEffect(() => {
    if (openModalpop) {
      dispatchSearch(selectBatchStat(true));
    } else {
      dispatchSearch(selectBatchStat(false));
    }
  }, [openModalpop]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && event.shiftKey) {
        event.preventDefault();
        navigate(-1);
      }
      if (event.key === "Enter" && openModal) {
        const activeElement = document.activeElement;
        if (activeElement.tagName === "DIV") {
          activeElement.click();
        }
      } else {
        return;
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate, openModal]);

  const handleProductDetailsClose = () => {
    dispatchSearch(openProductDetailsSearch(false));
  };

  const newSwal = Swal.mixin({
    customClass: {
      confirmButton: "button button-success",
      cancelButton: "button button-error",
      container: "my-swal-container",
    },
    buttonsStyling: false,
  });

  useEffect(() => {
    if (true) return () => {};
    const unsubscribe = subscribeOrderNotification(({ hasNewOrder, hasCreatedOrders }) => {
      handleOrderNotification({
        retailType,
        isDeliveryScreen: false,
        hasNewOrder,
        hasCreatedOrders,
        setBlinkIcon: (value) => dispatchSearch(setOdsNotif(value)),
      });

      const isDeliveryScreen = window.location.pathname === "/orders";

      if (hasNewOrder && !isDeliveryScreen) {
        fetchAllOrdersAndSlots();
      }
    });

    startNotificationPolling();

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (true) return () => {};
    const handleFirstInteraction = () => {
      unlockAudio();
      // Remove listeners after first interaction — no need to keep firing
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("keydown", handleFirstInteraction);
      window.removeEventListener("touchstart", handleFirstInteraction);
    };

    window.addEventListener("click", handleFirstInteraction);
    window.addEventListener("keydown", handleFirstInteraction);
    window.addEventListener("touchstart", handleFirstInteraction);

    return () => {
      window.removeEventListener("click", handleFirstInteraction);
      window.removeEventListener("keydown", handleFirstInteraction);
      window.removeEventListener("touchstart", handleFirstInteraction);
    };
  }, []);

  const handleMobileCategory = () => {
    setGoToMobileCategory(true);
  };

  // Shared search input onChange handler
  const handleSearchChange = (event) => {
    if (pathname === "/products/customertable") {
      debouncedCustomerSearch(event);
      dispatchSearch(setLoading(true));
    } else {
      debouncedClickPress(event);
    }
    if (pathname === "/products/orderstable") {
      dispatchSearch(orderFilter(event.target.value));
    }
    setSearchText(event.target.value);
  };

  const searchInputValue =
    pathname === "/products/orderstable" && order_text !== "" ? order_text : searchText;

  // ════════════════════════════════════════════════════════
  //  RENDER
  // ════════════════════════════════════════════════════════
  return (
    <>
      {/* <FloatingOrderIsland /> */}
      <Menu openMenu={openMenu} setOpenMenu={setOpenMenu} />
      <Backdrop className="backdrop-pos" open={isLoadingScreen} aria-hidden={!isLoadingScreen}>
        <PosActivityLoader />
      </Backdrop>
      {isLoggedIn ? (
        <E404Page />
      ) : (
        <>
          {renderWeighingModal()}
          {!openModalpop && weighingStatus !== "scanning" ? (
            <BarcodeReader
              key={counter}
              onScan={(sc) => {
                if (spDetails) return;
                setCounter(counter + 1);
                setBarcodeLoading(true);
                dispatchSearch(scanEnd(false));
                let startDate = new Date().getTime();
                setStartT(startDate);
                dispatchSearch(focusBarcode(true));
                if (
                  pathname == "/products/all-products" ||
                  pathname == "/restaurant/cart" ||
                  pathname === "/grocery/cart"
                ) {
                  const { newGtin, quantity } = checkGtinType(sc);
                  setQuantity(quantity || "");
                  setStartTime(new Date().getTime());
                  setProductCurrentTime(new Date().getTime());
                  const scanPayload = {
                    gtin: sc,
                    cartId: cartId,
                    locationId: locId,
                    orgId: orgId,
                    allowNegativeSelling: allowNegativeSelling,
                  };
                  if (pathname === "/grocery/cart") {
                    scanIntoGroceryCart(scanPayload);
                  } else {
                    doFetchInventory(scanPayload);
                  }
                  setSelectedGtin(sc);
                  setItemgtin(sc);
                }
              }}
              onError={(err, msg) => {
                dispatchSearch(focusBarcode(false));
                setBarcodeLoading(false);
                if (err.length > 1) {
                  if (msg === "Average key character time should be less or equal 90ms") {
                    play();
                    setSpModal(true);
                    setBarcodeErr(false);
                  }
                  if (msg === "String length should be greater or equal 6") {
                    play();
                    setSpModal(true);
                    setBarcodeErr(true);
                  }
                }
              }}
              avgTimeByChar={120}
            />
          ) : null}

          {spModal && (
            <Modal open={spModal} onClose={(e) => setSpModal(e)}>
              <Box
                sx={{
                  backgroundColor: "white",
                  color: "white",
                  position: isMobile ? "static" : "fixed",
                  top: "40%",
                  left: "35%",
                  width: isMobile ? "100%" : "40%",
                  borderRadius: "10px",
                  border: "no",
                  textAlign: "center",
                  ...(isMobile && {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }),
                  fontSize: "28px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "red",
                    paddingTop: "2%",
                    paddingBottom: "2%",
                    borderRadius: "10px",
                  }}
                >
                  <img src={error} className="error-img-barcode" alt="error" />
                </Box>
                <Box sx={{ paddingLeft: "2%", paddingRight: "2%", paddingBottom: "2%" }}>
                  <p className="text-in-modal">
                    {barcodeErr
                      ? "Invalid Barcode. Click or press enter scan again."
                      : "Barcode scanning failed. Click or press enter to continue"}
                  </p>
                  <div
                    id="click-me"
                    className="click-me-text"
                    ref={scanBarcode}
                    onClick={handleBarcodeErr}
                    tabIndex={0}
                  >
                    click me
                  </div>
                </Box>
              </Box>
            </Modal>
          )}

          <ProductDetailsPage
            openProductDetailModal={spDetails}
            handleProductDetailsClose={handleProductDetailsClose}
          />
          <NoDayStartedModalPopup sessionModal={sessionModal} />

          <Box className={color}>
            <BatchSelectionModal
              open={openModalpop}
              onClose={handleModalClose}
              mrps={mrps}
              disabled={disabled}
              selectedProduct={selectedProduct}
              selectedGtin={selectedGtin}
              handlePrice={handlePrice}
              addItemWithScanner={addItemWithScanner}
              selectedMrp={selectedMrp}
              SelectedSellingPrice={SelectedSellingPrice}
              batchNo={batchNo}
              purchasePrice={purchasePrice}
              sellingUnit={sellingUnit}
              offerData={offerData}
              availableUnits={availableUnits}
              expiryDate={expiryDate}
              brandName={brandName}
              packagingType={packagingType}
              variantName={variantName}
              vendorId={vendorId}
            />

            <Box
              className={`posContainer ${
                pathname === "/session-page/closing" && "posContainerPaddingBottom"
              }`}
            >
              <CssBaseline />

              {showTopNavbar && pathname !== "/session-page/day/closing" && (
                <TopNavbar
                  pathname={pathname}
                  color={color}
                  retailType={retailType}
                  currentPageLabel={currentPageLabel}
                  handleRedirect={handleRedirect}
                  tableLayoutRefetch={tableLayoutRefetch}
                  tableLayoutStats={tableLayoutStats}
                  cartRefetch={cartRefetch}
                  inputRefScan={inputRefScan}
                  setPlaceholderText={setPlaceholderText}
                  path={path}
                  handleSearchChange={handleSearchChange}
                  searchInputValue={searchInputValue}
                  focus={focus}
                  dispatchSearch={dispatchSearch}
                  clearSearch={clearSearch}
                  searchText={searchText}
                  increseScreen={increseScreen}
                  setHelpAndSupportDrawerOpen={setHelpAndSupportDrawerOpen}
                  handleOpen={handleOpen}
                  firstName={firstName}
                  showCamera={showCamera}
                  setShowCamera={setShowCamera}
                  cameraStyle={cameraStyle}
                  navigate={navigate}
                  changeColorFun={changeColorFun}
                />
              )}
              {false && pathname !== "/session-page/day/closing" && (
                <AppBar
                  position="fixed"
                  open={false}
                  className={
                    pathname === "/grocery/cart"
                      ? "newpayment-posNabar"
                      : "posNavbar"
                  }
                >
                  {/* ════════════════════════════════════════════
                      TOP NAVBAR  — 3-column Figma-matched layout
                      ════════════════════════════════════════════ */}
                  <div className={`topbar-brand-row ${color === "dark" ? "dark" : ""}`}>
                    {/* ── COL 1: Logo + Brand name (always "POS System" subtitle) ── */}
                    <div
                      className="topbar-brand"
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate("/products/operations-menu")}
                    >
                      <div className="topbar-logo-wrap">
                        <img className="topbar-brand-logo" src={PalletLynxLogo} alt="Pallet Lynx" />
                      </div>
                      <div className="topbar-brand-text">
                        <span className="topbar-brand-name">Pallet Lynx</span>
                        <span className="topbar-brand-sub">POS System</span>
                      </div>
                    </div>

                    {/* ── COL 2 (CENTER): Order Ready chip (restaurant always) OR page title ── */}
                    <div className="topbar-center">
                      {retailType === "RESTAURANT" ? (
                        <div className="topbar-notif-chip" onClick={() => setNotifDrawerOpen(true)}>
                          <div className="topbar-notif-left">
                            <div className="topbar-notif-icon-wrap">
                              <RestaurantOutlinedIcon
                                sx={{ fontSize: "0.95rem", color: "#16a34a" }}
                              />
                            </div>
                            <span
                              className={`topbar-notif-text ${
                                notifVisible ? "notif-slide-in" : "notif-slide-out"
                              }`}
                            >
                              {readyNotifications[
                                currentNotifIndex % Math.max(readyNotifications.length, 1)
                              ] || "Order Ready"}
                            </span>
                          </div>
                          {readyOrdersCount > 0 && (
                            <span className="topbar-notif-badge">{readyOrdersCount}</span>
                          )}
                        </div>
                      ) : currentPageLabel ? (
                        <div className="topbar-page-chip">
                          <span className="topbar-page-chip-dot" />
                          <span className="topbar-page-chip-text">{currentPageLabel}</span>
                        </div>
                      ) : null}
                    </div>

                    {/* ── COL 3: Search + action buttons ── */}
                    <div className="topbar-right-actions">
                      {/* Search bar — hidden on cart/product page */}
                      {pathname !== "/grocery/cart" &&
                        pathname !== "/restaurant/cart" && (
                          <div className="topbar-search-wrap">
                            <SearchIcon className="topbar-search-icon" />
                            <input
                              ref={inputRefScan}
                              id="search-input"
                              className="topbar-search-input"
                              placeholder={setPlaceholderText(path)}
                              tabIndex={-1}
                              onChange={handleSearchChange}
                              value={searchInputValue}
                              onKeyDown={(e) => focus(e)}
                              onFocus={() => dispatchSearch(setFocus(true))}
                              onBlur={() => dispatchSearch(setFocus(false))}
                            />
                            {!!searchText && (
                              <ClearIcon className="topbar-search-clear" onClick={clearSearch} />
                            )}
                          </div>
                        )}

                      {/* Refresh — table layout and cart pages */}
                      {(pathname === "/products/table-layout" ||
                        pathname === "/products/all-products") && (
                        <div
                          className="topbar-action-btn"
                          onClick={async () => {
                            if (globalRefreshLoader) {
                              setIsLoadingScreen(true);
                            }
                            try {
                              await Promise.all([
                                tableLayoutRefetch?.(),
                                cartRefetch?.(),
                              ]);
                            } catch (err) {
                              console.error("Refresh failed:", err);
                            } finally {
                              if (globalRefreshLoader) {
                                setIsLoadingScreen(false);
                              }
                            }
                          }}
                          title="Refresh"
                        >
                          <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
                            <path
                              fillRule="evenodd"
                              d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      )}

                      {/* Cash Drawer */}
                      <div
                        className="topbar-action-btn topbar-cash-drawer-btn"
                        title="Open Cash Drawer"
                        onClick={() => {
                          openDrawer();
                          showSnackbar("Cash drawer opened", "success");
                        }}
                      >
                        <span style={{ fontSize: "1rem", fontWeight: 700, lineHeight: 1 }}>₹</span>
                      </div>

                      {/* Fullscreen */}
                      <div
                        className="topbar-action-btn topbar-action-desktop-only"
                        onClick={increseScreen}
                        title="Toggle fullscreen"
                      >
                        <ArrowsPointingOutIcon style={{ width: "16px", height: "16px" }} />
                      </div>

                      {/* Support / Headset */}
                      <div
                        className="topbar-action-btn topbar-action-tablet-hide"
                        title="Help & Support"
                        onClick={() => setHelpAndSupportDrawerOpen(true)}
                      >
                        <HeadsetMicOutlinedIcon sx={{ fontSize: "1.1rem" }} />
                      </div>

                      {/* Avatar / Profile */}
                      <div onClick={handleOpen} className="topbar-avatar-btn" title="Profile">
                        <span className="topbar-avatar-initials">
                          {firstName?.[0]?.toUpperCase() || "U"}
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* ── end top navbar ── */}

                  {/* {pathname === "/grocery/cart" && <CartTableBar />} */}
                  <Modal
                    open={showCamera}
                    onClose={() => setShowCamera(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    className="user-modal-wrapper-box"
                  >
                    <Box className="modal-box" sx={cameraStyle}>
                      <h3 className="addCustomerText" style={{ margin: "0.5rem" }}>
                        Scan Barcode
                      </h3>
                      <div style={{ position: "relative", display: "flex" }}>
                        <img src={ScannerImage} alt="ScannerImage" className="scanner-image" />
                      </div>
                    </Box>
                  </Modal>
                </AppBar>
              )}

              {retailType === "RESTAURANT" && (
                <MenuAvailabilityDrawer
                  open={menuAvailabilityOpen}
                  onClose={() => setMenuAvailabilityOpen(false)}
                />
              )}

              <HoldOrderDrawer open={holdOrderDrawerOpen} onClose={closeHoldDrawer} />

              {helpAndSupportDrawerOpen && (
                <HelpAndSupportDrawer
                  open={helpAndSupportDrawerOpen}
                  onClose={() => setHelpAndSupportDrawerOpen(false)}
                />
              )}

              {logisticsDrawerOpen && (
                <LogisticsDrawer
                  open={logisticsDrawerOpen}
                  onClose={() => setLogisticsDrawerOpen(false)}
                />
              )}

              {expenseDrawerOpen && (
                <ExpenseDrawer
                  open={expenseDrawerOpen}
                  onClose={() => setExpenseDrawerOpen(false)}
                />
              )}

              {sessionDrawerOpen && (
                <SessionClosingDrawerV2 open={sessionDrawerOpen} onClose={closeSessionDrawer} />

                // <SessionClosingDrawer open={sessionDrawerOpen} onClose={closeSessionDrawer} />
              )}

              <SideNavigation
                open={open}
                handleRefresh={handleRefresh}
                orgLogo={orgLogo}
                tabList={tabList}
                path={path}
                color={color}
                showOdsTab={showOdsTab}
                goToLogin={goToLogin}
                openModal={openModal}
                handleClose={handleClose}
                style={style}
                firstName={firstName}
                secondName={secondName}
                isMobile={isMobile}
                increseScreen={increseScreen}
                setActiveTabComp={setActiveTabComp}
                setActiveIndex={setActiveIndex}
                navigate={navigate}
                changeColorFun={changeColorFun}
                handleLocation={handleLocation}
              />

              {false && (
                <Drawer
                  variant="permanent"
                  open={open}
                  sx={{ display: "none" }}
                  ModalProps={{ keepMounted: true }}
                  className="sideNav1"
                >
                  <List className="sideList">
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <DrawerHeader sx={{ marginTop: "0.5rem" }}>
                        <Box className="wrapper-text-box" onClick={handleRefresh}>
                          <img className="wrapper-logo-image" src={orgLogo || DefaultLogo} />
                        </Box>
                      </DrawerHeader>
                      <hr className="line" />
                      {tabList.map((item, index) => (
                        <ListItemButton
                          tabIndex={-1}
                          key={`${item?.label}-${index}`}
                          style={{ display: item?.hide ? "none" : "flex" }}
                          className={`
                          ${
                            item?.link?.includes(path)
                              ? "home-background-active"
                              : "home-text-navbar-I"
                          }
                          ${!!item?.notification ? "blinking" : ""}
                        `}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={item?.redirect}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              marginRight: 0,
                            }}
                            className={
                              item?.link?.includes(path)
                                ? color === "dark"
                                  ? "icon-active-dark"
                                  : "icon-active"
                                : "icon"
                            }
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {item?.icon}
                              <ListItemText
                                className={`
                                ${item?.link?.includes(path) ? "icon-active" : "home-text-navbar"}
                                ${
                                  item?.label === "Delivery" && !showOdsTab && "delivery-tab-status"
                                }
                                `}
                                sx={{ opacity: open ? 1 : 0 }}
                              />
                            </Box>
                          </ListItemIcon>
                        </ListItemButton>
                      ))}
                    </ListItem>
                    <div className="cashier-wrapper-box" style={{ marginBottom: "1rem" }}>
                      <hr className="line" />
                      <div className="name-avatar-box" onClick={() => goToLogin("active")}>
                        <LogoutIcon className="icon-color icon" />
                      </div>
                    </div>
                  </List>

                  {/* Profile modal */}
                  <Modal
                    open={openModal}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    className="user-modal-wrapper-box"
                    BackdropProps={{ invisible: true }}
                  >
                    <Box className="modal-box profile-actions-modal" sx={style}>
                      <Typography className="profile-actions-header">Profile Actions</Typography>

                      <Box
                        className="profile-action-item"
                        onClick={() => {
                          handleLocation();
                          handleClose();
                        }}
                      >
                        <Box className="profile-action-icon-wrap">
                          <StorefrontOutlinedIcon sx={{ fontSize: "1.25rem", color: "#4b5563" }} />
                        </Box>
                        <Box className="profile-action-icon-wrap-title">
                          <Typography className="profile-action-item-title">
                            Switch location
                          </Typography>
                          <Typography className="profile-action-item-subtitle">
                            Move to organization and location selection
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        className="profile-action-item"
                        onClick={() => {
                          setActiveTabComp(<Account />);
                          setActiveIndex(0);
                          navigate("/settings/accounts");
                          handleClose();
                        }}
                      >
                        <Box className="profile-action-icon-wrap">
                          <PersonOutlineOutlinedIcon
                            sx={{ fontSize: "1.25rem", color: "#4b5563" }}
                          />
                        </Box>
                        <Box className="profile-action-icon-wrap-title">
                          <Typography className="profile-action-item-title">
                            View profile
                          </Typography>
                          <Typography className="profile-action-item-subtitle">
                            Open operator details and preferences
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        className="profile-action-item"
                        onClick={() => {
                          navigate("/settings/roles-permissions");
                          handleClose();
                        }}
                      >
                        <Box className="profile-action-icon-wrap">
                          <ShieldCheckIcon
                            style={{
                              fontSize: "1.25rem",
                              width: "1.25rem",
                              height: "1.25rem",
                              color: "#4b5563",
                            }}
                          />
                        </Box>
                        <Box className="profile-action-icon-wrap-title">
                          <Typography className="profile-action-item-title">
                            Roles &amp; Permissions
                          </Typography>
                          <Typography className="profile-action-item-subtitle">
                            View your assigned roles and access
                          </Typography>
                        </Box>
                      </Box>

                      <Box className="profile-action-item" onClick={() => goToLogin("active")}>
                        <Box className="profile-action-icon-wrap logout">
                          <LogoutIcon sx={{ fontSize: "1.25rem", color: "#e53e3e" }} />
                        </Box>
                        <Box className="profile-action-icon-wrap-title">
                          <Typography className="profile-action-item-title">Logout</Typography>
                          <Typography className="profile-action-item-subtitle">
                            Sign out and return to login
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Modal>
                </Drawer>
              )}

              {children}

              {showBottomNavbar && (
                <BottomNavbar
                  tabList={tabList}
                  path={path}
                  retailType={retailType}
                  branchSubType={branchSubType}
                  cloudPrint={cloudPrint}
                  isPrinterOnlineForLocation={isPrinterOnlineForLocation}
                  storeMode={storeMode}
                  lat={lat}
                  long={long}
                  city={city}
                  country={country}
                  handleLocation={handleLocation}
                  sessionId={sessionId}
                  onLogout={() => window.dispatchEvent(new CustomEvent("pos:logout"))}
                  cartGrossBarVisible={cartGrossBarVisible}
                />
              )}

              {/* ── Bottom nav bar ── */}
              {false && (
                <div className="posnavbar-bottom-bar">
                  <div className="posnavbar-bottom-bar-left">
                    {tabList.map((item, index) =>
                      item.hide ? null : (
                        <div
                          key={index}
                          className={`posnavbar-bottom-btn ${
                            item.link?.includes(path) ? "posnavbar-bottom-btn-active" : ""
                          }`}
                          onClick={item.redirect}
                        >
                          <div className="posnavbar-bottom-btn-icon-wrap">
                            {item.icon}
                            {item.notification && <span className="posnavbar-notif-dot" />}
                          </div>
                          <span className="posnavbar-bottom-btn-label">{item.label}</span>
                        </div>
                      )
                    )}
                  </div>
                  <div className="posnavbar-bottom-bar-right">
                    {/* Printer status indicator */}
                    {retailType === "RESTAURANT" && branchSubType === "FINE_DINE" && cloudPrint && (
                      <div
                        className="posnavbar-printer-status"
                        title={
                          isPrinterOnlineForLocation ? "Printer Connected" : "Printer Disconnected"
                        }
                      >
                        <div className="posnavbar-printer-icon-wrap">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden="true"
                          >
                            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                            <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
                            <rect x="6" y="14" width="12" height="8" rx="1" />
                          </svg>
                          <span
                            className={`posnavbar-printer-dot ${
                              isPrinterOnlineForLocation
                                ? "posnavbar-printer-dot-online"
                                : "posnavbar-printer-dot-offline"
                            }`}
                          />
                        </div>
                      </div>
                    )}

                    {/* EDC machine status indicator */}
                    <div
                      className="posnavbar-payment-btn"
                      title={`EDC Machine: ${storeMode === "ONLINE" ? "Enabled" : "Disabled"}`}
                    >
                      <div className="posnavbar-printer-icon-wrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden="true"
                        >
                          <rect width="20" height="14" x="2" y="5" rx="2" />
                          <line x1="2" x2="22" y1="10" y2="10" />
                        </svg>
                        <span
                          className={`posnavbar-printer-dot ${
                            storeMode === "ONLINE"
                              ? "posnavbar-printer-dot-online"
                              : "posnavbar-printer-dot-offline"
                          }`}
                        />
                      </div>
                    </div>

                    <WeatherWidget
                      latitude={lat}
                      longitude={long}
                      city={city}
                      country={country}
                      onChangeLocation={handleLocation}
                    />
                  </div>
                </div>
              )}
            </Box>
          </Box>

          {/* confirmation modal for logout  */}
          <Modal
            open={openLogoutConfirmationModal}
            onClose={() => setOpenLogoutConfirmationModal(false)}
          >
            <div className="Confirmation___modal-backdrop">
              <div
                className="Confirmation___modal-container"
                role="dialog"
                aria-modal="true"
                aria-labelledby="confirmation-title"
                aria-describedby="confirmation-desc"
              >
                <h2 className="Confirmation___modal-title">Confirm Logout</h2>

                <p className="Confirmation___modal-text">
                  Are you sure you wanted to logout?
                  <br />
                  For logout please close the Session.
                </p>

                <div className="Confirmation___modal-actions">
                  <button
                    ref={closeBtnRef}
                    className="Confirmation___modal-btn Confirmation___modal-btn-close"
                    onClick={() => {
                      setOpenLogoutConfirmationModal(false);
                      setSessionDrawerOpen(false);
                    }}
                  >
                    Close
                  </button>

                  <button
                    ref={primaryBtnRef}
                    className="Confirmation___modal-btn Confirmation___modal-btn-primary"
                    onClick={() => {
                      setOpenLogoutConfirmationModal(false);
                      setSessionDrawerOpen(true);
                    }}
                  >
                    Go to Session
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          {/* Shortcuts modal */}
          <Modal
            open={shortcutModal}
            onClose={handleCloseShorctcutModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="user-modal-wrapper-box"
          >
            <Box sx={styleI} className="modal-main-wrapper-shortcut">
              <Box className="close-icon-wrapper-modal">
                <IconButton
                  className="shortcuts-close-icon"
                  onClick={handleCloseShorctcutModal}
                  autoFocus
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <KeyboardShortcuts />
            </Box>
          </Modal>
        </>
      )}
    </>
  );
}

Navbar.propTypes = {
  children: PropTypes.node,
  showTopNavbar: PropTypes.bool, // Add prop type
  showBottomNavbar: PropTypes.bool, // Add prop type
  globalRefreshLoader: PropTypes.bool,
};

export default memo(Navbar);
